import {
  goldTicketRules,
  rankRules,
  seniorReaderRules,
} from "./enUS/rankRules";
import { tag } from "./enUS/tag";

const Menus = {
  settings: "Settings",
  mates: "Mates",
  notifications: "Notifications",
  androidDownload: "Android",
};
const User = {
  dataCompleteness: "Data completeness",
  timeLimitedFree: "Time-limited free",
  superAdmire: "Subscription",
  fillName: "Change character name",
  shareAuthor: "Share Author",
  creator: "Creator",
  universe: "Universe",
  home: {
    like: "Like",
    following: "Following",
    followed: "Followed",
    oc: "OC",
    myOc: "My OC",
    story: "Story",
    novel: "Novel",
    moment: "Moment",
  },
  guardStatus: {
    1: "Time-limited free",
    2: "Time-limited free",
    3: "Time-limited free",
    4: "${amount} / month",
  },
  login: "Login",
  register: "Register",
  signout: "Sign Out",
  uploadAvatarHelp: "Click to upload a new profile picture",
  currentTokens: "Current Tokens:",
  tokens: "Tokens",
  mates: "Mates",
  bio: "Bio",
  bioPlaceholder: "Your introduction will be seen by the rest of the community",
  model: "Model",
  apiKey: "API Key",
  apiKeyPlaceholder: "Using API keys will no longer cost tokens",
  openAiKey: "OpenAI Key",
  currentMate: "Select Character",
  mate: {
    isNsfwVisible: "Is NSFW content visible",
    isNsfwBlurry: "Is NSFW content blurry",
    selectCharacter: "Select Character",
    selectWorldView: "Select World View",
    draft: "Draft",
    preset: "Sample",
    removeAllPreset: "Remove All Samples",
    unnamed: "Unnamed",
    following: "Following",
    completeProfile: "Complete Profile",
    currentSelected: "",
    follow: "Follow",
    addFriend: "Add Friend",
    hasBeenFriend: "Already a Friend",
    friendRequested: "Friend Requested",
    chatString: "Chat",
    guarding: "Admiring",
    guard: "Admire",
    guardianshipApplied: "Applied",
    noWorldView: "No World View, please create first.",
    basicInfo: {
      title: "Basic information",
      name: "Name",
      type: "Type",
      gender: "Gender",
      age: "Age",
      bio: "Bio",
      tag: "Tag",
      intro: "Scenario Intro",
      personality: "Personality",
      planet: "Planet&Worldview",
      bornPlanet: "Born Planet",
      currentPlanet: "Current Planet",
      birthday: "Birthday",
      race: "Race",
      occupation: "Occupation",
      worldview: "Worldview",
      relationWithMe: "Relation with me",
      personalityPrompt: "Personality",

      placeholder: {
        name: "[Required] Character's Name",
        type: "[Required] Character's Type",
        gender: "Character's Gender",
        age: "Age",
        bio: "Bio",
        tag: "Tag your character with up to 7 tags",
        intro:
          "Presented in a public, describe what do you want the player to do in the current scenario?",
        birthday: "Birthday",
        personality: "Personality",
        race: "Race",
        occupation: "Occupation",
      },

      rules: {
        name: "Please fill in the character's name",
        type: "Please fill in the character's type",
        gender: "Please fill in the character's gender",
        age: "",
        bio: "",
        tag: "Maximum 7 tags",
      },
    },

    module: {
      create: "Add Module",
      appearance: "Appearance",
      personality: "Personality",
      tone: "Tone",
      visibility: "Visibility",
      chat: "Chat",
      chatPrompt: "Prompt",
      chatEmotionPic: "Emotion Pic",
      chatImage: "Selfie",
      createCustom: "Create Custom Module",
      name: "Module Name",
      chatScene: "Scenario",
      basicInfo: "Basic Info",
      persona: "Relationship",
      sprite: "Sprite",
      feature: "Feature",
      gallery: "Gallery",
      story: "Story",
      game: "OC Gal",
      moment: "Moment",
      task: "Task",
      bgStory: "Background Story",
      relation: "Relationship",
      collection: "Collection",
      prop: "Attribute",
      relationship: "Relationship",
      chatList: "Chat List",
      ocSetting: "OC Setting",
      ocInteractive: "OC Interactive",
    },
    bgStory: {
      worldView: "World View",
      editWorldView: "Edit World View",
      worldViewName: "World View Name",
      enterWorldViewName: "Please enter the world view name",
      worldViewDescription: "World View Description",
      enterWorldViewDescription: "Please enter the world view description",
      noWorldView: "No World View, please create first.",
      personalExperience: "Personal Experience",
      relatedStorybook: "Related Storybook",
      replaceStorybook: "Replace Storybook",
    },
    relation: {
      myRelation: "My Relation",
      friend: "Friend",
      enemy: "Enemy",
      custom: "Add Custom Relation",
      addRelation: "Add Relation",
    },
    appearance: {
      avatar: "Avatar",
      coverImage: "Cover Image",
      bannerImage: "Banner Avatar Image",
      characterTraits: "Character Feature",
      scene: "Chat Background Image",
    },
    toneType: "Tone Type",
    selectTone: "Select Tone",

    setting: "Setting",
    visibility: {
      public: "Public",
      onlyFollower: "Followers Only",
      private: "Private",

      dynamicVisibilitySettings: "Moment Visibility",
      visibility: "Profile Visibility",
      isAllowedInjection: "Allow Relationship Injection",
      allowInjection: "Allow",
      notAllowInjection: "Not Allow",
      isUnfiltered: "This an Unfiltered Character?",
      filtered: "Filtered",
      unfiltered: "Unfiltered",
      dangerZone: "Danger Zone",
      dangerZoneHelp: "The last published character cannot be deleted",
    },
    chat: {
      chatSettings: "Chat Settings",
      chatPromptSetting: "Chat Prompt Settings",
      allowSwitchingToNSFW: "Allow switching to NSFW chat",
      onlyVisibilityToYou: "The following content is visible only to you",
      systemPrompt: "System Prompt",
      systemPromptTip:
        "System prompts are used to guide the character's response. For example: Only allow {'{{char}}'} to say things related to {'{{char}}'}, avoid repeating {'{{user}}'}'s dialogue and actions",
      personality: "Personality",
      personalityPlaceholder: `A concise description of the character's core traits, behaviors, and attitudes, setting the foundation for consistent interactions.`,
      greetingMessage: "First Message",
      scenario: "Scenario",
      scenarioTip:
        "Circumstances and context of the dialogue. Describe a scenario in which your character would be involved. For better immersion, try to describe the scenario as if it was happening right now",
      greetingMessagePlaceholder: `The First Message is an important thing that sets exactly how and in what style the character will communicate.

The character's first message should be long so that later it would be less likely that the character would respond with very short messages.

You can also use asterisks ** to describe the character's actions.

For example:

*I noticed you came inside, I walked up and stood right in front of you* Welcome. I'm glad to see you here. *I said with a toothy smug sunny smile looking you straight in the eye* What brings you...`,
      chatExample: "Chat Example",
      chatExamplePlaceholder:
        "Used to help the character adjust language style",
      example: "Example",
      pleaseUserInput: "Please fill in the user input",
      userInput: "User Input",
      simulatedUserInputText: "Simulated user input text",
      pleaseCharacterReply: "Please enter the character's reply",
      characterReply: "Character's Reply",
      textCharacterReply: "Text for the character's reply",
      tips: "Tips",
      placeholderTips:
        "You can use the variables {'{{char}}'} and {'{{user}}'} to orchestrate the story between the character and the user. During the chat, the system will automatically replace these variables with the names of the character and the user. \nFor example: {'{{char}}'} and {'{{user}}'} are a couple. \nIf the current character is 'Little Witch' and the user role is 'Sherlock', \nthis prompt will be parsed as: 'Little Witch and Sherlock are a couple' during the chat.",
    },

    attribute: {
      createCustom: "Create Custom Attribute",
      name: "Attribute Name",
    },
  },

  gallery: {
    all: "All",
  },

  admire: {
    name: "Admire",
    whoCanAdmire: "Who can admire me?",
    tips: "If you allow others to protect you, they will become co-creators after successfully doing so, and they can use your character in creating stories or games.",

    permission: {
      1: "Nobody",
      2: "Anyone without permission",
      3: "Anyone with my permission",
      4: "Pay to admire me",
    },

    // 高级守护
    super: "Subscription",
    superContent: `With this feature enabled, Anymate no longer restricts and censors content for its subscription when they chat privately with your mate.`,
    superTip: `child-friendly mate design can not activating this feature.`,
    superApply: "Apply to Enable",

    // 收到高级守护
    receivedContent: `We are reviewing your application.

We will inform you of the results via email and in-site notifications`,
    // 高级守护通过
    enabled: "Enabled",
    disabled: "Disabled",
    payTip: "Pay to be my subscriber",
    month: "/ month",
    minPayTip: "Minimum paid amount is ${amount} per month",
    disable: "Disable this feature",
    enable: "Enable this feature",

    feeTip:
      "Anymate will take a 30% cut of any admire and subscription fees that users pay for your mate",
  },

  subscription: {
    name: "Subscription",
    tips: "By subscribing to you, people will be able to see the content marked as 'Premium Subscribers' in your character's gallery.",

    otherTips:
      "You can unlock premium subscription content in the character's gallery by subscribing to this character.",
  },
  settingsSaved: "Settings Saved",
  settingsUnsaved: "Settings Unsaved",
  settingsSaving: "Settings Saving",
  scenarioSaved: "Scenario Saved",
  scenarioSaving: "Scenario Saving",
  gameDemoList: "Game Demo List",
};
const Buttons = {
  insertAnimationVerticalDrawing: "Insert animation vertical drawing",
  locationReset: "Location Reset",
  canvasReset: "Canvas Reset",
  newFeature: "New Feature",
  nextTime: "See you next time",
  modifyNaming: "Modify Naming",
  createPortrait: "Create portrait",
  editPortrait: "Edit portrait",
  modifyPicture: "Modify Picture",
  changeName: "Change name",
  placePicture: "Place picture",
  eraser: "Eraser",
  smear: "Smear",
  frameSelection: "Frame",
  lasso: "Lasso",
  selectRedrawArea: "Select Redraw Area",
  addPrompt: "Add Prompt",
  startRedrawing: "Start",
  saveNewPortrait: "Save as New Portrait",
  goToRepaintCanvas: "Go to repaint canvas",
  coverOriginalImage: "Cover Original Image",
  enterSmearCanvas: "Enter the smear canvas",
  regenerate: "Regenerate",
  profile: "Profile",
  importFromPublishedGames: "Import From Published Games",
  aiGenerateContentNode: "AI Generate Content Node",
  contentNode: "Content Node",
  aiCompletion: "AI Completion",
  ai: "AI",
  addDialogue: "Add Dialogue",
  addNarration: "Add Narration",
  AIGenerateDialogueNode: "AI Generate Dialogue Node",
  jumpToSettings: "Configure Jump",
  addReplyOption: "Add Reply",
  clickToFillIn: "Click to fill in",
  editPlotDialogue: "Edit Plot Dialogue",
  connectPlotPoint: "Connect Plot Points",
  chooseBackgroundMusic: "Choose bgm",
  uploadMusic: "Upload",
  addEnding: "Add Ending",
  editName: "Edit Name",
  editPlotPointOverviewDescription: "Edit Plot Point Overview Description",
  add: "Add",
  copyPlayLink: "Copy Play Link",
  viewHome: "View Home",
  viewUserHome: "View User Home",
  startGame: "Start Game",
  review: "Review",
  continue: "Continue",
  continueWriting: "Continue Writing",
  switch: "Switch",
  undo: "Undo",
  writing: "AI Writing",
  insert: "Insert",
  selectAll: "Select All",
  deselectAll: "Deselect All",
  listing: "Listing",
  delisting: "Delisting",
  addMoment: "Add Moment",
  preview: "Preview",
  exitPreview: "Exit Preview",
  splitSettings: "Split Settings",
  merge: "Merge",
  chooseImage: "Choose Image",
  quickGenerate: "Quick Generate",
  customGenerate: "Custom Generate",
  replace: "Replace",
  manualCreation: "Manual Creation",
  copy: "Copy",
  copyText: "Copy Text",
  autoGenerate: "Automation",
  read: "Read",
  clearSelection: "Clear Selection",
  done: "Done",
  newmate: "New Mate",
  create: "Create",
  apply: "Apply",
  batchApply: "Batch Apply",
  root: "Root",
  edit: "Edit",
  delete: "Delete",
  editPersonalityPrompt: "Edit Personality",
  generateIntro: "Generate Intro",
  chatnow: "Chat Now",
  chat: "Chat",
  publish: "Publish",
  syncDataAndPreview: "Sync Data and Preview",
  fork: "Fork",
  save: "Save",
  back: "Back",
  stop: "Stop",
  isGenerateCoverIntro: "Generating Cover Intro",
  confirm: "Confirm",
  reset: "Reset",
  cancel: "Cancel",
  close: "Close",
  overview: "overview",
  genealogy: "Genealogy",
  markAsRead: "Mark as read",
  view: "View",
  verify: "Verify",
  createThread: "Create Thread",
  createImage: "Create Image",
  createStory: "Create Story",
  createNewCharacter: "Create New Character",
  createPost: "Create Post",
  skip: "Skip",
  newTask: "New Task",
  agree: "Agree",
  deny: "Deny",
  update: "Update",
  createCustom: "Create Custom {name}",
  createAttribute: "Create Attribute",
  deleteModule: "Delete Module",
  deleteCharacter: "Delete Character",
  deleteWorldview: "Delete Worldview",
  deleteAccount: "Delete Account",
  uploadImage: "Upload Image",
  uploadVideo: "Upload Video",
  uploadAudio: "Upload Audio",
  new: "New",
  select: "Select",
  selected: "Selected",
  addChatExample: "Add Chat Example",
  sure: "Sure",
  upload: "Upload",
  allAlbum: "All Album",
  createPublicChat: "Create Public Chat",
  createPrivateChat: "Create Chat",
  collapse: "Collapse",
  expand: "Expand",
  allReplies: "All Replies",
  createForTa: "Create for This Character",
  savedAlbum: "Saved Gallery",
  generateImage: "Preview",
  lexicon: "Lexicon",
  editLexicon: "Edit Lexicon",
  generateVideo: "Generate Video",
  generate: "Generate",
  viewAll: "View All",
  deleteReferenceImage: "Delete Reference Image",
  brush: "Brush",
  selectBackgroundImage: "Select Background Image",
  changeBackgroundImage: "Change Background Image",
  clear: "Clear",
  selectCharacterImage: "Select Character Image",
  all: "All",
  recentChat: "Recent Chat",
  newChapter: "New Chapter",
  nextChapter: "Next Chapter",
  lastChapter: "It's already the last chapter",
  previousChapter: "Previous Chapter",
  firstChapter: "It's already the first chapter",
  momentSave: "Save",
  submit: "Submit",

  createNewGame: "Create New Game",
  gamePlay: "Play",
  insertEmoji: "Insert Emoji",
  gameOnly: "Game Only",
  momentUpdate: "Moment Update",

  switchCharacters: "Switch Mate",
  clearBg: "Clear Background",
  clearCharacterAndAnimation: "Clear Character and Animation",
  clearCanvas: "Clear Stage",

  loginToReply: "Login Anymate to Reply",
  toDiscord: "Feedback",

  shareToMoments: "Share to Moments",
  play: "Play",

  addImage: "Add Image",
  horizontalFlip: "Horizontal Flip",
  lockOrUnlock: "Lock/Unlock",

  withdrawSetting: "Withdraw Setting",
  bind: "Bind",
  importFromCharaCard: "Import Tavern Card",

  exchange: "Exchange",
  notSetTone: "Not Set Tone",

  superAdmireSuccess: "Subscription Success",
  loginToChat: "Login Anymate to Chat",
  getApp: "Get APP",

  ok: "OK",
  next: "Next",

  manage: "Manage",
  get: "Get",
  startChat: "Start Chat",
  allTags: "All Tags",
  trending: "Trending",
  popular: "Most Popular",
  editorChoice: "Editor's Choice",
  setDefault: "Set Default",
  playScene: "Play",

  trial: "Trail",
  enroll: "Enroll",
  createGame: "Create OC Gal",
  editProfile: "Edit Profile",
  viewCharacterCard: "View OC Card",
  writeDown: "Write Down",
  writeStory: "Write Story",
  applyList: "Apply List",

  import: "Import",
  event: "Event",
  sort: "Sort",
  swapSort: "Swap Sort",
  editContent: "Edit Content",

  createWorldview: "Create Worldview",
  relation: "Relation",
  goTo: "Go to",
  registerOrLogin: "Register & Login",
  handDraw: "Hand Draw",
  setting: "Setting",
  paymentCompleted: "Payment Completed",
  paymentCancelled: "Payment Cancelled",
  contactCustomerService: "Contact Customer Service",
  advanced: "Advanced",
  enterHome: "Enter House",
  homeActivityLog: "Activity in House",
  treehole: "Tree Hole",
  viewMore: "View More",
  interactionLog: "Interaction Log",
};
const Titles = {
  community: "Community",
  me: "Me",
  mymates: "My Mates",
  displayLanguage: "Display Language",
  mateLanguage: "Mate’s Language",
  chattextcolor: "Chat Text Color",
  createForTa: "Create For Him",
  splitSettings: "Split Settings",
  releaseGame: "Release Game",
  previousConversation: "Previous Conversation",
  nextConversation: "Next Conversation",
  unmute: "Unmute",
  mute: "Mute",
  exitSceneMode: "Exit Scene Mode",
  scene: "Scene",
  trendingTags: "Trending Tags",
  resultCount: `{count} results for<span class="text-primary">"{keyword}"<span>`,
  features: "Features",
  others: "Others",
  friends: "Friends",
  inviteFriends: "Invite Friends",
  relationship: "Relationship",

  // 能量箱
  energyBox: "Energy Box",
  createOC: "Create OC",
  dreamHome: "Dream Home",
  sprite: "Sprite",
};
const Tabs = {
  hot: "Hot",
  new: "New",
  top: "Top",
  private: "Private",
  draft: "Draft",
  published: "Published",
  latest: "Latest",
  myCreations: "My Creations",
  recommend: "Recommended",
};

const Newmates = {
  delete: "Delete",
  draft: "Draft",
  name: "Mate's Name",
  namePlaceholder: "Please enter your mate's name",
  namePrompt: "Your name is:",
  yourmateavatar: "Your mate’s avatar",
  chat: "Chat",
  gender: "Gender",
  male: "Male",
  female: "Female",
  unisex: "Unisex",
  notSet: "Not Set",
  crop: "Crop",
  reset: "Reset",
  coverintro: "Cover intro",
  coverinfo1:
    "The following content will be generated based on personality information",
  coverinfo2: "Waiting for generation",
  appearance: "Appearance",
  personality: "Personality",
  tone: "Tone",
  overview: "Overview",
  avatargallery: "Avatar Gallery",
  suggested: "Suggested",
  uploaded: "Uploaded",
  upload: "Upload",
  personalityprompt: "Mate Personality",
  personalitypromptHistory: "Append History",
  describe: "Describe your mate's personality. For example, cute.",
  autocomplete: "Auto-Complete",
  save: "Save",
  suggestedprompt: "Suggested Prompt",
  enterdialogue: "Enter Dialogue for Character Voice Preview",
  currenttone: "Current Tone:",
  play: "Play",
  tonegallery: "Tone Gallery",
  select: "Select",
  selected: "Selected",
  untitled: "Untitled Mate",
};
const Chats = {
  chooseChat: "Choose Chat",
  basicSettings: "Basic Settings",
  modelTip:
    "Select the Language Model in chat, this will affect the style of the chat and fee charged",
  name: "Chat Session Name",
  nameTip: "Display name of the chat session",
  thumbnail: "Thumbnail",
  chatMode: "Chat Mode",
  audio: "Audio",
  audioAutoPlay: "Automatically play audio for messages",
  deleteCurrentChat: "Delete Current Chat",
  publishedAt: "Published at:",
  published: "Published",
  unpublished: "Unpublished",
  append: "Append",
  appendPrompt: "Append Personality",
  chat: "Chats",
  cast: "Cast",
  currentChat: "Current Chat",
  empty: "No Message",
  generate: "Generate",
  style: "StyleLab",
  scene: "Scene",
  selectSceneImage: "select a scene image",
  summary: "Summary of previous conversation",
  publishMate: "Publish Mate",
  tellAboutMate: "tell other about your mate",
  tellAboutMateExample:
    "Example: This is my carefully trained Mate, the dream Japanese teacher.Can someone ask my Yae Miko out for a drink? Successful I kneel to him!",

  saysomething:
    "Say something to your mate.  (⌘ + ↩ or ⌃ + ↩ start a new line )",
  send: "Send",
  typing: "is typing...",
  master: "Master",
  scenePlaceholder:
    "Enter the scene description information to make the reader more immersed ",
  sceneDescription: "Scene Description",
  sceneHelp: "Describe the background to make it more immersive for the reader",
  selectAll: "Select All",
  showMore: "Show More",
  says: "Says to",
  to: "",

  all: "All",
  actors: "Actors",
  toMate: "To Mate",
  toActors: "To Actors",

  chooseCharacterToChat:
    "Choose a character to chat with&nbsp;<spna class='text-primary'>{name}</spna> ",

  createChat: "You are preparing to initiate a chat with ",
  createChatHalf:
    ", Public chats will be visible to the mysterious owner behind Ta. If you don't want your chat to be seen, please use a private chat",
  initiateChat: "How to initiate a chat?",
  publicChat: "Public",
  publicOne: "Exchange about the real world is possible",
  publicTwo: "Responses may not be immediate",
  publicThree: "The mysterious force behind will observe",

  privateChat: "Private",
  privateOne: "Private chats won't be visible",
  privateTwo: "Responses are very prompt",
  privateThree: "Multiple conversations can be expanded",

  waitingTips: {
    0: "Setting up the environment",
    1: "Applying makeup for the character",
    2: "Selecting clothes for the character",
    3: "Choosing a hairstyle for the character",
    4: "Scheduling activities for the character",
    5: "Taking a break",
    6: "Why isn't it loaded yet? Can't continue writing",
    7: "Alright, just a little more wait. It'll be ready soon!",
  },
  noInitiatedPublicChat: "Public chat has not been initiated yet",
  noInitiatedPrivateChat: "No Started Chat",

  proxyEnabled: "Proxy Responses Enabled",
  proxyDisabled: "Disabled Proxy Responses",
  proxyEnabling: "Enabling Proxy Responses",
  sendMsgTo: "To {name}",
  voiceAutoPlay: "Voice Auto-play Enabled",
  publicHelpHalf: "You are having a public conversation with ",
  publicHelpTwo:
    ". This conversation can be seen by the mysterious force behind them. Please refrain from using offensive, violent, or provocative language.",
  privateHelpHalf: "You are having a private conversation with ",
  privateHelpTwo: ". The content of this conversation is visible only to you",
  connecting: "Connecting...",

  invalidExt: "Character cards only support the png and json formats.",
  noPngMetaData: "The current image does not contain any character data.",
  failToParseCard:
    "Failed to parse the character card. Please check if the file is correct.",
  enablingLoverMode: "Enabling Lover Mode",
  disablingLoverMode: "Disabling Lover Mode",
  unlockEntireMsg: "Unlock the Entire Message",
  autoUnlock: "Auto-unlock",
  mateHome: "Mate Home",
  messageTypeLabel: "Input",
  replyTypeLabel: "Reply",
  messageType: {
    message: "Message",
    text: "Text",
    instruction: "Instruction",
    inputIntro:
      "The input is used to mark your input to enhance the model's response performance.",
    messageIntro:
      "Message is a single piece of dialog from yourself, the user. It may contain a direct quote, but also some description of the mate's actions or thoughts.",
    textIntro:
      "Text is a plain part of the role-play story, and not attributed to any character. It's often used to describe the scene, provide background, etc.",
  },
  replyType: {
    text: "Text Reply",
    replyIntro:
      "The reply is used to control the content returned by the model, allowing you to better advance and control the progression of the story.",
    random: "Default",
    replyBy: "Reply by Mate",
    textIntro:
      "The text is a plain part of the role-play story, and not attributed to any character. It's often used to describe the scene, provide background, etc.",
    replyByIntro:
      "Control the model to play the role of mate and reply with a piece of dialogue. It may contain a direct quote, but also some description of the mate's actions or thoughts.",
    randomIntro: "The next reply content is entirely decided by the model.",
  },
  continue: "Continue",
  selectChatOnTheLeft: "Select a character on the left to start chat",
  selectModel: "Select Model",
  tokenLimit: "Token Limit",
  perMessage: "Per Message",
  supportLanguage: "Support Language",
  lang: {
    all: "All",
    en: "English",
  },
  censored: "Censored",
  uncensored: "Uncensored",
  chatSessions: "Chat Sessions",
  recentPost: "Recent Post",
  mateEmotion: {
    intro:
      "Emotion Pics are images randomly returned in chats. The AI calculates the relevance of the images based on 'emotion name'. If there are related images, they will be sent along with the text response.",
    name: "Emotion Name",
    nameTip:
      "In the chat, the AI will match the emotion name you input with the chat content and display the corresponding emotion pic in the background.",
    editTip:
      "After confirming the addition/update, your emotion pic updates will take effect immediately. In an ongoing chat, the AI will instantly match the emotion name with the chat content, displaying the current image to users chatting with your character at the background.",
    emptyTitle: "No Emotion Pics",
    emptyDesc:
      "Click the button in the upper right corner to add an emotion pic",
    addDefault: "Auto Add Default Emotion",
  },
  chatImage: {
    intro:
      "Selfies are images that character will send to user, when the user asks for a selfie. Then trigger is in 'plus' icon (at the right side of chat input, besides the Send Msg button) - 'Send Me a Photo'.",
    price: "Price",
    priceTip:
      "The price of the selfie. If the price is over 0, the user needs to pay to view the whole photo. min price is 0.5 crystal.",
    priceNotSetTip: "Min price is 0.5 crystal",
    editTip: "After confirming the addition/update.",
    emptyTitle: "No Selfie",
    emptyDesc: "Click the button in the upper right corner to add a selfie",
    free: "Free",
  },
  advancedOption: "Advanced Options",
  chatScene: {
    name: "Scenario",
    tip: "The Scenario describes the setting, situation, or context in which the interaction with the character takes place. It provides important background information that influences the conversation.",
    genericScenario: "Generic",
    isCommon: "This is a Generic Scenario?",
    isCommonTip:
      "Generic scenarios and roles are not strongly tied to each other, and they can be used apply to any character. They often use placeholders like {'{{char}}'} and {'{{user}}'} to replace the names of characters and users.",
    emptyTitle: "No Scenario",
    emptyDesc: "Click the button in the upper right corner to add an Scenario",
    specific: "Specific",
    generic: "Generic",
    edit: {
      basic: "Basic",
      desc: "Description",
      descTip:
        "The Scenario describes the setting, situation, or context in which the interaction with the character takes place. It provides important background information that influences the conversation.",
      firstMsg: "First Message",
      firstMsgTip:
        "The First Message is the initial text the AI character sends when starting a new chat. It should introduce the character and set the stage for the interaction, reflecting their personality and the scenario.",
      systemPrompt: "System",
      systemPromptTip:
        "The System Prompt is an optional component that provides additional context and instructions to the AI model. It helps guide the AI's behavior and responses in a more specific manner.",
      shortDesc: "Short Description",
      shortDescPlaceholder:
        "A short description for the scenario, only for displaying",
      shortDefinition: "Short Definition",
      shortDefinitionPlaceholder:
        "How should the AI determine the value by how much should the value be increased or decreased",
      coverImage: "Cover Image",
      coverImageTip: "Animation Gif is recommended",
      roundsLimit: "Rounds Limit",
      roundsLimitPlaceholder: "After reaching rounds limit, chat will be over",
      name: "Name",
      namePlaceholder: "Scenario Name",
      target: "Target",
      targetDesc:
        "As the game progresses, which numbers change as the player progresses through the game",
      targetNamePlaceholder: "Target Name",
      type: "Type",
      default: "Default",
      condition: "Condition",
      reaction: "Reaction",
      winning: "Winning",
      losing: "Losing",
      endingScript: "Ending Script",
      targetNameInfo:
        "The target name will be displayed as the name in the chat and serves as an important basis for AI-driven interactions. Please use a clear and concise name. If the target name is deleted, the target will be removed.",
      eventNameInfo:
        "The event name will be displayed as the name in the chat and serves as an important basis for AI-driven interactions. Please use a clear and concise name.",
      numericalNamePlaceholder: "Numerical Name",
      numericalNameInfo:
        "The numerical name will be displayed as the name in the chat and serves as an important basis for AI-driven interactions. Please use a clear and concise name. If the numerical name is deleted, the numerical will be removed.",
      add: "Add",
      preview: "Preview",
      from: "From",
      to: "To",
      generate: "Generate",
      reactionTips: "Keywords for generate reaction",
      overwrite: "Overwrite",

      event: "Event",
      eventPlaceholder: "Event Name",
      eventDesc:
        "Random events that occur during the game can add uncertainty to the player's experience flow",
      probability: "Probability",
      definition: "Definition",

      character: "Character",
      characterDesc: "The characters that appear in the scenario",
      characterSelect: "Select Character",

      // 数值相关
      numerical: "Numerical",
      numericalSelect: "Select Numerical",
      applyCharacter: "Apply Characters",
      noTarget:
        "The current character does not have any goals, and the player will not be able to play this character",
      winTarget: "Winning Target",
      failReason: "Fail Reason",
      attr: "Attr",
      value: "Value",

      relatedEvent: "Related Event",

      deleteCharacterTips:
        "Deleting a character will automatically remove the character bound to the numerical, and also remove the target related to the character. Confirm deletion?",
      deleteEventTips:
        "Deleting an event will automatically remove all events bound to the numerical definition. Confirm deletion?",
      deleteScore:
        "Deleting a numerical will automatically remove all numerical prompts bound to the numerical definition. Confirm deletion?",
      scoreType1: "Status",
      scoreType2: "Attribute",
      noTarget2: "This character does not have any target.",
      noScore: "This character does not have any numerical.",
      yourTurn: "Your Turn",

      // 位置相关
      position: "Position",
      positionNamePlaceholder: "Position Name",
      currentPosition: "Current Position",
      positionDescPlaceholder: "A short description for the position, ",
      enterCondition: "Enter Condition",
      enterConditionPlaceholder:
        "The conditions for how the AI ​​determines whether the character can enter the scene.",
      leavingCondition: "Leaving Condition",
      leavingConditionPlaceholder:
        "The conditions for how the AI ​​determines whether the character can leave the scene.",
      accessibleDefinition: "Accessible Definitions",
      connectLocation: "Other places you can reach",
      containCharacter: "Appearing Characters",

      noOtherPosition:
        "No other places you can reach, Please add a position first",
      childrenPosition: "Sub-position",
      selectDestination: "Select reachable locations",
      pleaseAddCharacter:
        "No characters available, please add a character first",

      deleteParentPositionConfirm:
        "Deleting the parent position will automatically remove all sub-positions. Confirm deletion?",
      deleteParentCharacterConfirm:
        "Deleting the parent position's characters will automatically remove all characters added to the sub-positions. Confirm deletion?",
      deleteParentDestinationConfirm:
        "Deleting the parent position's reachable locations will automatically remove all reachable locations added to the sub-positions. Confirm deletion?",
      pleaseAddNameFirst: "Please add a name first",
      notInSamePosition: "Character and player are not in the same position",
    },
  },
  matePersona: {
    tip: "Relationship can serve as an extension of optional character prompts by appending 'personality summary' and 'system prompts' to the character setup prompts. This is used to enhance the character’s behavior and chatting style.",
    name: "Name",
    description: "Description",
    nameTip: "Name of relationship, only used for displaying",
    descriptionTip: "description of relationship，only used for displaying",
    emptyTitle: "No Relationship",
    emptyDesc:
      "Click the button in the upper right corner to add a Relationship",
    default: "Default Persona",
  },
  noPicForYouNow: "No Photo for You Now",
  thinking: "Generating Reply...",
  generateError: "Failed to generate reply, click to try again",
  noPicAvailable: "This character have not prepared any photos yet",
  picExhausted: "All photos have been viewed",
  sendMePhoto: "Send Me a Photo",
  noPhoto: "No Photo",
  translateLanguage: "Translate Language",
  assistantFeature: "Assistant Features",
  enteringOptionMode: "Entering option mode...",
  selectMateTone: "Select Mate Tone",
  selectNarratorTone: "Select Narrator Tone",

  maleVoice: "Male Voice",
  femaleVoice: "Female Voice",
  targetWin: "You Have Won the Game!",
  targetLose: "You Have Lost the Game!",
  targetReach: "{targetName} has reached {targetScore}",
  pickNewMate: "Pick a New Mate",
  restartGame: "Restart Game",
  game: "Game",
  success: "Success",
  failed: "Failed",
  timeFastForward: "Time Fast Forward",
  timeFastForwardTip: "Fast forward the story time to advance the plot",
  fastForwardOneDay: "One Day",
  fastForwardOneWeek: "One Week",
  fastForwardOneMinute: "One Minute",
  fastForwardOneHour: "One Hour",
  actions: {
    say: "Say",
    do: "Do",
    sneak: "Sneak",
    move: "Move",
    fight: "Fight",
    items: "Items",
    mixed: "Mixed",
  },
  confirmAction: "Confirm to try {action} to {name}?",
  confirmFight: "Confirm to try fight {name}?",
  temperature: {
    title: "Randomness",
    low: "Rigid",
    high: "Creative",
    tip: "Influences the character's responses. The higher the value, the more likely the character is to give unexpected answers. The lower the value, the more likely the character is to stick to the script.",
  },
  chooseReplier: "Choose Replier",
};

const ChatCast = {
  avatar: "Cast's avatar",
  intro: "Intro",
  name: "Name",
  newCast: "New",
  noCasts: "No Casts",
  position: "Position",
  relation: "Relation",
};

const loginmodal = {
  cancel: "cancel",
  login: "Login",
  hasAccount: "Log In",
  email: "Email Address",
  googleLoginInfo: "Sign in with Google",
  signInWithApple: "Sign in with Apple",
  emailplaceholder: "Please enter your email address",
  emailplaceholderCorrectly: "Please enter your email correctly",
  continuewithemail: " Continue with Email ",
  text: "By clicking Continue with Google/Email/Phone above, you acknowledge that you have read and understood, and agree to Anymate’s Terms and Privacy and Privacy Policy",
  sendcode: "Send code",
  verifyCodeSentSuccess: "Verification Code Sent Successfully",
  invalidCode: "Invalid Code",
  resend: "Resend code",
  resendHit: "Resend available in ",
  resendHit2: "seconds",
  verificationcode: "Verification Code",
  inputVerificationCode: "Please enter the verification code",
  staticCode: "Static Code",
  viewFollowUp: "View follow-up moments after logging in",
  viewLoggingIn: "View the moments of people you follow after logging in",
  continue: "Continue",
  prevStep: "Prev",
  nextStep: "Next",
  register: "Register a New Account",
  male: "Male",
  female: "Female",
  createYourCharacter: "Create Your Character",
  setAvatar: "Create an Anime-style Avatar",
  characterAppearance: "Character Appearance",
  selectPhoto: "Select Photo",
  randomGenerate: "Random Generate",
  selectStyle: "Select Style",
  confirmAndGenerate: "Confirm and Generate",
  regenerate: "Regenerate",
  characterName: "Character Name",
  enterName: "Please enter name",
  enterEmail: "Please enter email",
  theLastStep: "The Last Step",
  welcome: "Welcome to Anymate",
  enterCommunity: "Enter Community",
  downloadImage: "Download Image",
  skip: "Skip",
  generating: "Generating, Please do not refresh the page...",
  receiving: "Receiving, Please do not refresh the page...",
  avatarClickTipTitle: "Almost there!",
  avatarClickTip:
    " After completing registration, you will be able to download high-resolution avatars",
  downloadAvatarTip:
    "After clicking the 'Download Image Button', long-press the image to save it to your gallery.",
  notSetGender: "Not Set Gender",
  setYourRole: "Your Role in Chat",
  prepare: "Prepare",
  phone: "Phone Number",
  phoneplaceholder: "Please enter your phone number",
  phoneplaceholderCorrectly: "Please enter your phone number correctly",

  switchToEmail: "Switch to Email Login",
  switchToPhone: "Switch to Phone Login",

  currentVersion: "Current Version",

  loginAgreement: "By logging in, you agree to",
  registerAgreement: "By registering, you agree to",
  userAgreement: "User Agreement",
  privacyPolicy: "Privacy Policy",
  and: "and",
  inviteCode: "Invite Code",
  inviteCodePlaceholder: "Please enter invite code",
  switchToLogin: "Already have an account, go to login",
  switchToRegister: "No account, go to register",
};
const card = {
  try: "Try it for free",
  discuss: "Discuss:",
  fork: "Fork:",
};
const Language = {
  mateSelect: "Mate's Language",
  english: "English",
  chinese: "Chinese",
};

const Texts = {
  notLike: "Don't like",
  like: "Like",
  backHome: "Back Home",
  node: "Node",
  beenReachedEn: "The end has been reached",
  stillNothingTheAlbum: "Still nothing in the gallery",
  insertPicture: "Insert Picture",
  displayText: "Display Text",
  enterName: "Please enter name",
  chooseStory: "Choose Story",
  selectChapter: "Select Chapter",
  whenChapterPublishedYourFeed:
    "When chapters are published they will appear in your feed",
  whenVisualNovelPublishedYourFeed:
    "When the visual novel is shared to the moments, it will be visible to all users",
  whenVideoPublishedYourFeed:
    "When the video is shared to the moments, it will be visible to all users",
  chapterPublishedNotModify:
    "Chapters cannot be modified after they are published",
  contentChapter: "Let me introduce to you the content of this chapter.",
  contentChapterPlaceholder:
    "The content filled in here will be published as dynamic text and chapters.",
  chatRecord: "Chat record",
  textMode: "Text mode",
  sceneMode: "Scene mode",
  characterSettings: "Character Settings",
  characterPortrait: "Character Portrait",
  verticalPainting: "Vertical Painting",
  animation: "Animation",
  canvas: "Canvas",
  zoom: "Zoom",
  coordinate: "Coordinate",
  redrawWidth: "Denoising Strength",
  portraitName: " Portrait Name",
  newVerticalPaintingName: "New Vertical Painting Name",
  redrawPromptWord: "Redraw Prompt Words",
  pleaseEnterPromptWord:
    "Please enter the prompt words (only supports English, separated by English commas)...",
  redrawBasedTh: "Redraw based on {index}th picture",
  cloneSelectedNodeBelow: "Clone below the selected node",
  lastedit: "Last edit at:",
  fordToEdit: "After you create a Fork, you can chat with Mate",
  afterSentences: "after {amount} sentences",
  notModified: "current chat cannot be modified.",
  mateIntroDesc:
    "The above content is an introduction for other users. It has no effect on characters or character setting. Click on the text area to edit.",
  noIntroductionText: "This person hasn't provided any introduction for now",
  characterImage: "Character Image",
  clickUpperRight: "Click the button in the upper right corner to add an image",
  allComments: "All comments",
  submittedCreationForTa:
    "will receive your submitted creation, and once approved, the creation will be published to their moments.",
  submittedCreationPlaceholder:
    "Share your thoughts with {mateName} here. It will help expedite the review process.",
  splitSettingText:
    "Split settings will divide each paragraph in the entire article based on the separator symbol. You can insert images between each split segment.",
  afterCompletingFromText:
    "After completing the form, you can choose to refer to other content",
  completeContent: "Please complete the content here",
  saveTime: "Save Time",
  gamePublished:
    'After the game is published, it will appear in your "Moments"',
  gamePublishedNotModified:
    "After the game is published, it cannot be modified",
  introGame: "Let's introduce the game content to everyone",
  introCollection: "Introduce the content of the collection to everyone",
  gamePublishedPlaceholder:
    "The content entered here will be posted as the main body of the feed along with the game",
  sharePlaceholder:
    "The content entered here will be published as the body of the dynamic text along with the share",

  estimatedRemainingTime: "Estimated remaining time",
  createAt: "Create at",
  promptText: "Prompt Text",
};

const Message = {
  addingPleaseTryAgainLater: "Adding, please try again later...",
  chooseConversation: "Choose the conversation",
  regeneratingAudio: "Regenerating Audio",
  regeneratedAudioSuccessfully: "Re-generated audio successfully",
  regeneratedAudioFailed: "Failed to regenerate audio",
  inCutting: "In cutting...",
  creatingStoryIllustrationTask: "Creating a story illustration task",
  parsingThePicture: "Parsing the picture",
  overlaySuccess: "Overlay Success",
  overwritingOriginalFeature: "Overwriting the original feature...",
  generatingFeature: "Generating feature...",
  creatingFeature: "Creating feature...",
  pleaseEnterFeatureName: "Please enter a feature name",
  newTaskBeenCreated: "New task has been created",
  taskCompletedPleaseCheckToMarked:
    "The task has been completed, please check to be marked",
  checkingTheTask: "Checking the task",
  cancelSuccessfully: "Cancel successfully",
  cancellingMission: "Cancelling a task",
  needFeatures:
    "You need to create character features before using the painting function",
  changingCover: "Changing cover",
  creatingDynamicPictureTask: "Creating dynamic picture task",
  enterAnimationName: "Please enter animation name",
  createAStoryFirst: "Please create a story first",
  noStory: "No stories available yet",
  selectAddToStory: "Select a story to add to",
  chapterIntoStory: "Stuffing chapters into the story",
  storyModifiedSuccessfully: "Story modified successfully",
  storyCreatedSuccessfully: "Story created successfully",
  enterStoryName: "Please enter a story name",
  enterStoryDesc: "Please enter a story description",
  selectStoryCover: "Please select a cover image",
  textGeneratedToast:
    "The writing style case refers to the writing style of the story you want to generate. It is recommended to fill in the writing style case to make the style of the generated content more stable.",
  chapterPublishedSuccessfully: "Chapter published successfully",
  releasingChapterUniverse: "Releasing chapters to the universe...",
  autoSaveFailed: "Auto save failed",
  chapterCopying:
    "Chapters are being sent to the Universe Archives for copying",
  chapterCopiedSuccessfully: "Chapter copied successfully",
  soundPlaybackError: "Sound playback error",
  processingImage: "Processing image...",
  newsSeemsMissing: "The message seems to disappear",
  dynamicDisappearedInto: "This dynamic disappeared into the universe",
  wordCountLimited: "Word count limited to {number}",
  settingScene: "Setting the scene",
  cancelAutomaticPlay: "Cancel automatic audio playback",
  automationPlay: "Audio automation play",
  enablingAudioPlay: "Enabling audio autoplay",
  closingAudioPlay: "Closing audio autoplay",
  enabledSuccessfully: "Enabled successfully",
  closedSuccessfully: "Closed successfully",
  exitingSceneMode: "Exiting scene mode",
  unlockScenes: "Unlock scenes",
  lockScenes: "Lock scenes",
  onceUnlocked:
    "Once unlocked, the scene will change as the conversation progresses",
  onceLocked:
    "Once locked, the scene will not change as the conversation progresses",
  reachedBeginningTime: "We have reached the beginning of the timeline",
  viewMorePreviousConversations: "Viewing more previous conversations",
  currentMaxTen: "Currently a maximum of 10 items are allowed to be selected",
  partnerPublishedSuccessfully: "Your partner has been published successfully",
  apiKeyCannotEmpty: "apiKey cannot be empty",
  forkSuccessful: "FORK successful",
  nodeCloning: "Node cloning...",
  nodeCloneSuccessfully: "Node clone successfully",
  cloningFailed: "Cloning failed, please try again",
  addingRetry: "Adding, please try again later",
  addThisRoleFirst: "Please add this role first",
  conversationAdditionFailed: "Conversation addition failed",
  updatedSuccessfully: "Updated successfully",
  createdSuccessfully: "Created successfully",
  resetting: "Resetting...",
  whetherResetThisContent: "Whether to reset this content",
  alreadyLatestVersion: "Already the latest version",
  newVersionDetected: "New version detected",
  updatedToTheLatestVersion: "Updated to the latest version",
  someMoreContentUpload:
    "Some more content is being uploaded, please wait a moment",
  someContentUploadFailed:
    "Some content failed to upload, please delete or try again",
  recap: "Recap",
  enterChapterName: "Please enter a chapter name",
  enterChapterDescription: "Please enter a chapter description",
  selectChapterCover: "Please select a chapter cover",
  creatingChapter: "Creating chapter...",
  savingChapter: "Saving chapter...",
  creatingStory: "Creating story...",
  savingStory: "Saving story...",
  chapterModifiedSuccessfully: "Chapter modified successfully",
  chapterCreatedSuccessfully: "Chapter created successfully",
  updatingFeature: "Updating feature...",
  failedUpdateFeature: "Failed to update feature",
  deleteFeature: "Delete feature",
  lastFeatureNotDeleted: "It's the last feature. It can't be deleted",
  sureRemoveFeature: "Are you sure you want to remove this feature?",
  deletingFeature: "Deleting feature",
  cloningFeature: "Cloning feature",
  failedDeleteFeature: "Failed to delete feature",
  featureCloningFailed: "Feature cloning failed",
  confirmCloneTrait: "Confirm cloning of current feature?",
  fetchingCharacterPortraitList: "Fetching character portrait list",
  removingCharacterPortraitBackground: "Removing character portrait background",
  unnamedCharacterPortrait: "Unnamed character portrait",
  savingCharacterPortrait: "Saving character portrait",
  failedDeleteCharacterPortrait: "Failed to delete character portrait",
  deleteCharacterPortrait: "Delete character portrait",
  delete: "Delete",
  redrawing: "Redrawing...",
  covering: "Covering...",
  coverageSuccessful: "Coverage successful",
  updatingVerticalPainting: "Updating the vertical painting",
  failedToUpdateVerticalPainting: "Failed to update vertical painting",
  creatingVerticalPainting: "Creating vertical painting",
  exitRedrawnImage:
    "Exiting will clear unsaved redrawn images. Are you sure to exit?",
  deletingCharacterPortrait: "Deleting character portrait",
  confirmDeletion: "Confirm deletion of {name}",
  deleteConfirm: "Confirm Deletion?",
  noPromptText: "No Prompt Text",
  taskAdded: "Task Added",
  progress: "In Progress...",
  addingCharacter: "Adding Character",
  pleaseAddCharacterFirst: "Please add a character first",
  AIGenerating: "AI Generating...",
  AIGenerate: "AI Generate",
  pullRefresh: "Pull to refresh",
  releaseRefresh: "Release to refresh",
  clickSelectCharacter: "Click to select a character",
  nothingWasWritten: "It seems like nothing was written",
  choosePeopleRemind: "Choose the people to remind",
  successfully: "successfully",
  promptcopied: "prompt has copied",
  promptsaved: "prompt has saved",
  likeTone: "likeTone",
  createMate: "createMate",
  beforeCreate: ` After your Mate is created, its Appearance and Tone
  cannot be modified. Are you sure you want to create it now?`,
  beforePublish: `After publish your Mate, the chat content between you and Mate will be seen by all users, and the chat record between you and Mate cannot be modified. Are you sure to release it now?`,
  publishing: "Publishing, please wait...",
  savingProgress: "Saving in progress...",
  sure: "Sure",
  cancel: "Cancel",
  saving: "Saving...",
  storySaving: "Saving story",
  saveSuccess: "Save Success",
  saveFailed: "Save Failed",
  publishSuccess: "Publish Success",
  shareSuccess: "Share Success",
  publishFailed: "Publish Failed",
  flippingThroughStoryBook: "Flipping through a storybook...",
  storyNoCreate:
    "Have you created a story collection yet? We will create one for you based on the statuses you regularly post.",
  snacksDuringChatPreparation: "Snacks during Chat Preparation",
  noMoreAvailable: "No more available",
  currentCreateStory:
    "Current character has not created any chapters for the story",
  thisChapterNoContent: "This chapter has not content",
  requestFailedClickToReload: "Request Failed, Click to Reload",
  loading: "Loading...",
  unlocking: "Unlocking...",
  unlockSuccess: "Congratulations!🎉 Unlocking successful!",
  noContentAvailable: "No content available",
  noCharactersAvailable: "No characters available",
  noTraitsAvailable: "No feature available",
  noMateAvailable: "No mate available",
  noGame: "No games available",
  noMateChangeKeywrod: "Unable to find Mate, please try another keyword",
  noMatchingRole: "No matching roles found, please try another keyword",
  noPendingReviews: "No pending reviews yet",
  noCompletedReviews: "No completed reviews",
  noCreationsPendingReview: "No creations pending review",
  noCompletedCreationsYet: "No completed creation yet",
  noAnimation: "No animation yet",
  approved: "Approved",
  rejected: "Rejected",
  allNow: "That's all for now",
  unknown: "Unknown",
  notBio: "This person has not provided any biography",
  noGreetingIntro: "No scenario intro for now",
  deletingCharacter: "Deleting Character",
  deletingAttribute: "Deleting Attribute",
  failDeleteAttribute: "Failed to delete attribute",
  creatingModule: "Creating Module",
  failCreateModule: "Failed to create module",
  deletingModule: "Deleting Module",
  failDeleteModule: "Failed to delete module",
  characterNameRequired: "Please fill in the character's name to publish",
  creatingAttribute: "Creating Attribute",
  failCreatingAttribute: "Failed to create attribute",
  uploading: "Uploading...",
  uploadSuccessful: "Upload Successful",
  uploadFailed: "Upload Failed",
  noStoriesYet: "No stories yet",
  noStoriesYetDesc: "The current character hasn't created any stories yet",
  noStoriesPublishedYet: "No stories published yet",
  noStoriesPublishedYetDesc:
    "The current character hasn't published any stories yet",
  noGamesYet: "No games yet",
  noGamesYetDesc: "The current character hasn't created any games yet",
  settingChatEnvironment: "Setting up the chat environment",
  deletingPrivateChat: "Deleting Private Chat",
  sureExit: "Are you sure you want to exit?",
  operationFailed: "The operation failed",
  applicationSentSuccessfully: "Admire application sent successfully",
  fetchTraitList: "Fetch feature list",
  generatingPromptWords: "Generating Prompt Words...",
  characterAlbum: "Saving to Character Gallery...",
  savedAlbum: "Saved to gallery",
  creatingVideoTask: "Creating Video Task",
  preparingImage: "Preparing to infuse soul into the image",
  savingAlbum: "Saving to the gallery",
  savingDialog: "Saving to dialogue background...",
  creatingImageGenerationTask: "Creating an image generation task",
  creatingStorySceneTask: "Generating visual novel",
  creationSuccessful: "Creation Successful",
  preparingToCreateCharacter: "Preparing to Create Character",
  switchingCharacters: "Switching Characters",
  loadingCharacter: "Loading Character...",

  inOperation: "In Operation",
  noChatTitle: "No chat messages available",
  noChatDesc: "No saved chat messages available",
  noChatHistoryYet: "No chat history yet",
  noChatHistoryYetDesc: "There are no chat records to share here.",
  selectShareChat: "Select chat history to share",
  deleting: "Deleting",
  modifying: "Modifying",
  deleteSuccessful: "Delete Successful",
  switchingChatMode: "Switching Chat Mode",
  switchSuccessful: "Switch Successful",
  deletingStory: "Deleting Story...",

  noMomentsYet: "No moments yet",
  storyNoMoment: "The current story has no associated moments",
  theCurrentChapter: "The current chapter does not have any associated moments",
  deletingChapter: "Deleting Chapter...",
  deleteChapterSuccessful: "Delete Chapter Successful",

  generatingLongImage: "Generating long image",
  longPressSaveImage: "Long press to save",
  rightClickImage: "Right-click select 'Save As' to save",

  selectMoment: "Select moment",
  keywordEnterSerach: "Enter keywords and press Enter to search",

  searchEnter: "Search for characters/moments, press Enter to search",
  searchPlaceholder: "Search in Anymate",
  searchMateEnter: "Search for characters/works, press Enter to search",
  hotCharater: "Hot Characters",
  chatWithHotCharacter: "Chat with Hot Character",
  moreCharacters: "More Mates",
  featuredCharacter: "Featured Mates",
  featuredScenario: "Featured Scenario",
  replace: "Replace",

  search: "Search",
  inputKeywordsToSearch: "Please Input Keywords to Search",
  notRelatedMomentFound: "No related moments found",

  noWelcomeMoment: "No Recommendations available at the moment",
  noRecommendedRoles: "No recommended roles at the moment",
  pleaseEnterVerificationCode: "Please enter the complete verification code",
  incorrectVerificationCode: "Incorrect verification code",
  oh: "Oh!",
  connectionFaild: "Oh! Connection to the universe failed.",

  displayName: "Display Name",
  enterDisplayName: "Please enter display name",
  englishPrompt: "English prompts",
  enterEnglishPrompt: "Please enter English prompts",
  submissionSuccessful: "Submission successful",
  submissionFailed: "Oh! Submission failed",

  completeChapterBeginning: "Please complete the chapter beginning first",
  completeChapterEnding: "Please complete the chapter ending first",

  loadingStory: "Loading story...",
  otherVersion: "Other version",
  nothingWritten: "Seems like nothing has been written",
  creating: "Creating...",

  copySuccessful: "Copy Successful",
  removingRole: "Removing Role...",
  noDialoguesAvailable: "No dialogues available",
  noTxAvailable: "No Transaction Available",
  pleaseSelectDialogText:
    "Please select the dialogue to jump to, or add more dialogues",
  pleaseSelectContentNode: "Please select a content node",

  noSelectableNodeAvailable: "No selectable nodes available",
  pleaseEnterAudioName: "Please enter the audio name",
  untitledMusic: "Untitled Music",
  notWrittenIntro: "Introduction has not been written yet",
  publishingGame: "Publishing game...",
  publishingShare: "Publishing share...",
  importing: "Importing...",
  importingSuccess: "Import Success",
  updateLogNotBeenFilledYet: "Update log hasn't been filled yet",
  updateLogVersionError: "The version number is smaller than before",

  reachedEnd: "Reached the end",
  promptNotBeenFilledYet: "Prompt has not been filled yet",
  sourceNotBeenFilledYet: "The reference image has not been uploaded yet",

  notLogin: "Sorry, You have not logged in yet",
  checkingTicket: "Checking ticket...",

  checkingUpdate: "Checking for updates...",
  updating: "Updating...",
  noUpdate: "Already the latest version",
  switchingLanguage: "Switching language...",
  storyContentCanNotEmpty: "Story content cannot be empty",

  paymentSuccessful: "Payment Successful",
  paymentCancelled: "Payment Cancelled",

  // 跳转支付中...
  paymentRedirecting: "Redirecting to payment...",

  editTrait: "Would you like to go to the edit feature page?",
  editTraitConfirm:
    "Going to the edit feature page will lose the current edited content. Are you sure you want to proceed?",
  createTrait: "Would you like to go to the create feature page?",
  createTraitConfirm:
    "Going to the create feature page will lose the current edited content. Are you sure you want to proceed?",
  twoFinger: "Two-finger drag",
  switchingAccount: "Switching Account...",
  deletingAccount: "Deleting Account...",

  customPoseTip: `It is recommended to use the preset visual style provided by the platform. If you choose to customize the visual style, please provide more descriptive words to avoid strange-looking visuals.`,
  mutiUserTip:
    "It is recommended to use a custom visual style, otherwise the visuals may look strange.",

  applyPending: "Application successful, please wait for review~",
  swapping: "Exchanging...",
  exchangeSuccess: "Exchange successful",
  notEnoughCrystal: "Not enough love crystals.",

  uploadNotAllow:
    "This resource contains sensitive information, please upload it again.",
  tapToClose: "-Tap to close-",

  deleteReplyConfirm: "Are you sure you want to delete this comment?",
  reportTip: "Please enter the reason for reporting",
  blockUserConfirm: "Are you sure you want to block this user?",

  blockReplyContent: "[This comment has been deleted]",
  opSuccess: "Operation Successful",

  imageLoading: "Image Loading",
  imageLoadFailed: "Image Load Failed",
  imageReload: "Reload Image",

  mateTraitNotExist:
    "This feature has been deleted by yourself and cannot be edited.",
  type: "Type",
  discussion: "Discussion",
  mineCharacter: "Mine",
  clearPromptMessage: "Are you sure you want to clear the prompt message?",
  totalCount: "Total Count",

  donateSuccess: "Donate Success",

  donateTooHigh: "Donation amount is too high. The maximum amount is 10000",
  donateTooLow: "Donation amount is too low. The minimum amount is {amount}",
  default: "Default",
  custom: "Custom",
  noThumbnail: "No Thumbnail",
  removeThumbnail: "Remove Thumbnail",
  textGeneration: {
    generate: "Gen",
    continue: "Continue",
    overwrite: "Overwrite",
    inspiredText: "Inspired Text",
    text: "Plain Text",
    preview: "Preview",
    emptyText: "Please Input in Plain Text Mode to get Markdown Preview",
    inspirePlaceholder: "Keywords for Generating {label}",
  },
  chatInModulePageTip:
    "To chat with the current character, The current changes will be submitted and leave this editing page to select another character to start chatting. Are you sure?",
  notAllowInjection: "This character does not allow relationship injection",
  unfiltered: "Unfiltered",
  filtered: "Filtered",
  longImage: "LONG",
  azureError: "Upload Image needs to be less than 4MB",
  searchForSuitableForChat: "Only Search for Suitable for Chat",
  createNewTag: "Create",
  presetTag: "Promoted",
  fillRequiredFields: "Please fill in the required fields",
  joinDiscordTip:
    "Join Discord! Get up to <span class='text-primary-content font-bold'>100 free chats</span> every day!",
  redeemLoginTip: "Login to Release Your Free Chat Limit",
  congratulations: "Congratulations!",
  redeemSuccessTip: "Your free chat limit has been increased to 100 per day",
  restFreeChat: "Today Free Chat",
  pleaseInputTargetName: "Please input target name",
  pleaseInputNumericalName: "Please input numerical name",

  // targetReaction
  reactionNumberError: "Reaction number range error, please check",
  pleaseFillChatSceneName: "Please fill in the scene name first",
  pleaseFillChatSceneDescription: "Please fill in the scene description first",
  pleaseFillReactionName: "Please fill in the reaction name first",

  // chatScene event
  pleaseFillChatSceneEventName: "Please fill in the event name first",
  chatSceneEventProbabilityError: "Event probability cannot be 0",
  pleaseFillChatSceneEventDefinition:
    "Please fill in the event definition first",
  pleaseAddEventFirst: "No available events, please add event first",

  serverUpgradingTitle: "Server Maintenance",
  serverUpgrading: `We will be conducting scheduled server maintenance on {startTime} - {endTime}. During this period, AI Chat and AI Drawing services will be temporarily unavailable. This maintenance is necessary to ensure the continued performance and stability of our platform.

We apologize for any inconvenience this may cause and appreciate your understanding. `,

  none: "None yet",
  xCount: "{count}",

  titleRequired: "Please enter the title",
  nameRequired: "Please enter the name",
  descriptionRequired: "Please enter the description",

  notFriend: "Please add them as a friend first",

  createImageInfo:
    "The image creation function is being evaluated cautiously... Please add a staff member's WeChat first if you need an image, the code is: 'image', and we will help you create it as soon as possible!",

  bindSuccess: "Bind Success",

  inviterMessage:
    "【{mate}'s exclusive invitation link] \nCome and join my OC Club!",
  inviterMessage2: "Click to become my friend! → {link}",

  noPermissionToViewRole: "No permission to view this role",

  dragModuleToSort: "LongPress and Drag modules to sort",

  createTemplate: "Create Template",
  createTemplateTitle: "Create Template Name",
  createTemplateSuccess: "Template created successfully",
  failCreatingTemplate: "Failed to create template",
  clickToImport: "Click to select the module to import",
  importTemplateTitle: "Import Module",
  importTemplateInfo: "Are you sure you want to import the module?",
  importTemplateSuccess: "Module imported successfully",
  failImportTemplate: "Failed to import module",

  deleteTemplateTitle: "Delete Template",
  deleteTemplateInfo: "Are you sure you want to delete the template?",
  deleteTemplateSuccess: "Template deleted successfully",
  failDeleteTemplate: "Failed to delete template",

  noTemplateAvailable: "No available templates, please create one first!",
  importingTemplate: "Importing template...",
  deletingTemplate: "Deleting template...",

  oversize: "File size cannot exceed {size} MB",

  noAttribute: "No custom attributes yet, click the button below to add!",
  cannotEditPresetModule: "Cannot edit preset module name",

  settingSuccess: "Setting Success",
  contentHasAiContent: "Contains AI Content",
  contentIsAiGenerated: "This content is generated by AI",

  timelineOrderDuplicate:
    "The sort ID: {order} already exists, do you need to automatically increase the sort ID of the subsequent sort IDs by 1?",
  updatingTimeline: "Updating timeline...",
  registerFirst: "You haven't registered an account yet, please register first",

  deletePresetCharacter:
    "Are you sure you want to delete this preset character?",
  deletePresetCharacterConfirm:
    "Deleting this preset character will remove all associated content. Are you sure you want to proceed?",

  cannotDeleteThisPlanet:
    "This planet is associated with a character and cannot be deleted",
  cannotDeleteThisPlanet2: "The last planet cannot be deleted",

  loadingPlanet: "Loading planet...",

  confirmRemoveRelation: "Confirm to remove the relation?",

  publishMateFillWorldview: "Please select a planet first",
  publishMateFillName: "Please fill in the character name first",

  underConstruction: "Under construction...",
  purchaseSuccess: "Purchase Successful",
  verificationFailed: "Verification failed",
  deleteAccountSuccess: "Account deleted successfully",
  createSampleOC: "Creating sample OC...",

  registerToStart: "Register to start your OC creation journey",
  androidVersionTip:
    "This feature may experience crashes on Honor and lower Android versions. If this occurs, please try using Chrome Browser to open it.",
  processingPayment: "Processing your payment...",
  creatingOrder: "Creating order...",
  confirmPayment: "Please confirm if the payment has been completed",
  paymentNotCompleted: "Payment not completed",
  crystalPaymentSuccess: "{count} crystals have been charged to your account",
  filterAlbum: "Filter by character",
  uploadToWhichAlbum: "Upload to which character's album?",
};
const Reply = {
  reply: "Reply",
  replies: "Replies",
  saysomething: "Say something...",
  enterYourReply: "Enter your reply",
  popular: "Popular comments",
  reader: "Reader's comments",
  noComments: "No Comments Yet",
  noCommentsDesc: "No comments have been made yet",
  edit: "Edit Reply",
};
const Media = {
  uploadFailed: "Upload failed",
  fileSizeExceed: "File size cannot exceed {size} MB",
  fileFormatDisallowed: "File format only supports {extension}",
};

const ConfirmModal = {
  areYouSureResetCanvas: "Are you sure you want to reset the canvas?",
  clearCanvas: "This will clear everything on the canvas",
  cancelEditInfo: "Information has not been saved, are you sure to leave?",
  confirmApptovalTitle: "Confirm Approval",
  confirmApptovalInfo:
    "Once approved, this post will be added to your feed, and everyone will be able to see it.",
  confirmRejectionTitle: "Confirm Rejection",
  confirmRejectionInfo:
    "Rejecting this post will prevent it from being added to your feed.",
  deleteExampleTitle: "Delete Chat Example",
  deleteExampleInfo: "Are you sure you want to delete this chat example?",
  deleteMateTitle: "Delete Character",
  deleteMateInfo:
    "This action cannot be undone. Are you sure you want to delete the current character?",

  deleteModuleAllInfo:
    "This action cannot be undone. Are you sure you want to delete it?",
  deleteAttributeTitle: "Delete Attribute",
  deleteAttributeInfo: "Are you sure you want to delete the current attribute?",
  deleteModuleTitle: "Delete Module",
  deleteModuleInfo: "Are you sure you want to delete the current module?",
  cancelEditingTitle: "Cancel Editing",
  cancelEditingInfo:
    "Are you sure you want to cancel editing the current character",
  deletePrivateChatTitle: "Delete Chat",
  deletePrivateChatInfo: "Are you sure you want to delete the chat?",
  exitTitle: "Confirm Exit",
  promptTitle: "Prompt Title",
  deleteCharacterImage:
    "Are you sure you want to delete the character reference image?",
  goingEditInfo:
    "Going to the lexicon will result in the loss of prompt words. Confirm going to edit?",
  switchCharacterImageInfo:
    "Switching characters will clear the selected images. Continue?",
  clearTheCanvas: "Clear the Canvas?",
  deleteCurrentChatTitle: "Delete Current Chat",
  deleteCurrentChatInfo:
    "Once deleted, it cannot be recovered. Are you sure you want to delete it?",
  deleteChapter: "Delete Chapter",

  confirmDeleteReply: "Confirm Delete Reply?",
  deleteReplyCannotRecovered: "Delete reply cannot be recovered",
  confirmDeleteThisMoment: "Confirm Delete this Moment",
  deleteMomentCannotRecovered: "Delete moment cannot be recovered",
  areYouSureDeleteNode: "Are you sure you want to delete this node?",

  cancelPublish: "Cancel Publish",
  cancelPublishInfo:
    "Your post has not been published yet. Are you sure you want to cancel?",
  deleteCharacter: "Are you sure you want to delete this character?",

  googleLoginTitle: "Please sign in with 3rd party account in a new window",
  googleLoginInfo: "Have you successfully logged in a new window?",

  confirmTitle: "Confirm",
  notSaved: "Not saved",
  confirmInit: "Confirm initialization?",
  confirmSaveChanges: "Confirm saving changes?",
  confirmNotSave: "Confirm not saving?",
  sureDeleteDisplayText: "Are you sure you want to delete {displayText}",

  unfollowTitle: "Unfollow",
  sureUnfollowText: "Are you sure you want to unfollow {name}?",

  cancelCreation: "Cancel creation",
  cancelCreationText:
    "The creation has not been submitted yet. Are you sure you want to cancel?",

  sureDeleteImageText: "Are you sure you want to delete this image?",

  saveNotCompleteText:
    "Saving will not complete the content and will directly use the current chapter. Confirm saving and generating the chapter?",

  clearTitle: "Clear",
  sureClearText: "Confirm clearing?",

  sureDeletePost: "Are you sure you want to delete this moment?",
  sureDeleteText: "Confirm deleting?",

  deleteDialogue: "Delete Dialogue",
  deleteDialogueText: "Are you sure you want to delete this dialogue?",
  deleteOption: "Delete Option",
  deleteOptionText: "Are you sure you want to delete this option?",
  enterContent: "Enter Content",
  rating: "Rating",

  deleteNode: "Delete Node",
  deleteNodeText:
    "After deleting the node, all its content will be permanently deleted and cannot be recovered. Are you sure you want to proceed with the deletion?",
  deleteCharacterText:
    "Deleting a character will remove all of its associated dialogues",

  protagonistExists: "A protagonist already exist",
  protagonistExistsText: "Switch Protagonist?",
  deleteActivationCondition:
    "Are you sure you want to delete the activation conditions for this node?",

  sureSwitchTitle: "Confirm Switch",
  sureSwitchDesc: "Canvas content will be saved. Confirm switching?",

  sureOverrideTitle: "Confirm Apply",
  sureOverrideDesc: "Canvas content will be override. Confirm overriding?",

  deleteMusic: "Delete Music",
  deleteMusicText: "Are you sure you want to delete this music?",

  deleteTone: "Delete Tone",
  deleteToneText: "Are you sure you want to delete this tone?",
  clearContent: "Clear Content",
  clearContentText: "Are you sure you want to clear the content?",

  deleteMessage: "Delete Message",
  deleteMessageText: "Are you sure you want to delete this message?",
  modifyMessage: "Modify Message",
  modifyMessageText: "Are you sure you want to modify this message?",

  confirmDeleteCollectionItem:
    "Are you sure you want to delete this collection item?",

  enableAutoPlay: "Enable Voice AutoPlay",
  enableAutoPlayDesc: "Voice AutoPlay provides a better immersive experience.",
  enableAutoPlayDesc2:
    "Due to browser restrictions, auto-play needs your confirmation after each refresh.",
  autoPlayOk: "Start!",
  autoPlayCancel: "Not Now",
  deleteAccountTip:
    "This action cannot be undone. It will permanently delete your account along with all your characters.",
  deleteAccountTip2: "{count} characters below will also be deleted",
  inputEmailToConfirm: "Please input your email to confirm",
  permanentlyDelete: "Permanently delete account and {count} characters",
  notSupportMateSwitchTitle: "Notice",
  notSupportMateSwitchDesc:
    "Switch Mate is not supported in this page, You will go back to Home page if you confirm to switch",
  reloadApp: "Reload the App",
  reloadAppDesc: "Modifying this setting need to reload the app to take effect",

  confirmToEditWorldview: "Confirm to edit this worldview?",
  confirmToRemoveAllPreset: "Confirm to remove all preset characters?",
};

const Community = {
  fork: "Fork: ",
  gen: "Gen: ",
  chat: "Chat: ",
  publishedAt: "Published at: ",
  hot: "Hot",
  new: "New",
  top: "Top",
  current: "Current",
  thGen: "{number} th Gen",
  root: "Root",
  showGenealogy: "Show Genealogy",
  dungeon: "Dungeon",
  moment: "Moment",
  story: "Story",
  video: "Video",
  game: "Game",
  galGame: "Game",
  rank: "Leaderboard",
  gallery: "Gallery",
  myOCMoments: "My OC Moments",
  friendsMoments: "Friends Moments",
  starPlanet: "Star Planet",
};

const Overview = {
  info: "Info",
  type: "Type",
  birthday: "Birthday",
  generation: "Generation",
  forkCount: "ForkCount",
  likes: "Likes",
  comments: "Comments",
  feedback: "Feedbacks",
  storyFeedback: "Feedbacks",

  overview: "Overview",
  popularSnippets: "Popular Snippets",
  genealogy: "Genealogy",
  reviews: "Reviews",
  updateTime: "Update Time",
};

const Image = {
  info: "Info",
  size: "Size",
  date: "Date",
  type: "Type",
  originalImage: "Original Image",
  partialRedraw: "Partial Redraw",
  smudgeRetouching: "Smudge retouching",
  fusionRedraw: "Fusion Redraw",
  redraw: {
    handRepair: "Hand Repair",
    addObject: "Add Object",
    detailRepair: "Detail Repair",
    deleteObject: "Delete Object",
    changeClothes: "Change Clothes",
    changeExpression: "Change Expression",
  },
};

const Notifications = {
  receiveNewNotification: "Receive new notification",
  title: "Notifications",
  unread: "Unread",
  read: "Read",

  btn: {
    allRead: "Mark all as read",
  },

  message: {
    characterNotExist: "Character does not exist",
  },

  type: {
    agreedGuardianRequest: "Agreed to your friend request",
    declinedGuardianRequest: "Declined your friend request",
    replyMentioned: "You were mentioned in a comment by {mateName}:",
    repliedMoment: "{mateName} replied to your moment",
    repliedTextImage: "{mateName} replied to your image",
    repliedComment: "{mateName} replied to your comment",
    wantGuardYou: "{mateName} wants to be your friend",
    mentionedMoment: "{mateName} mentioned you in a moment:",
    storyVideoGenerated: "Story: {title} video has been generated",
    storyGenerated: "Story: {title} has been generated",
    approvedContentCreated: "Approved the content you created for them",
    declinedContentCreated: "Declined the content you created for them",
    followedYou: "Followed you",
    guardedYou: "has become your friend",
    messageFrom: "Message from {mateName}",
    createContentForYou: "{mateName} created content for you",
    imageGenerationComplete: "Image generation complete",
    likeMoment: "{mateName} liked your moment",
    likeTextImage: "{mateName} liked your image",
    donate: "{giver} contributed ${amount} to you",
    coinVote: "{giver} voted for your",
    becomeSeniorReader: "Senior reader application approved",
    collectionInvited: "{name} invited you to join the collection",

    superAdmireSuccess: "Your subscription application has been approved!",
    superAdmireFailed: "Your subscription application has been rejected!",
    mediaPurchased: "{name} purchased your work. You received ${amount}",
    mateAdmireSubscribed:
      "{name} has successfully subscribed to your premium content. You received ${amount}",
    ChatMessageEarned:
      "{name} interacted with your character in a chat. You earned ${amount}",
  },
  system: "System Notification",
  guardingCanceled: "Admiring cancelled",
  subType: {
    comment: "Comment",
    reaction: "Reaction",
    follow: "Follow",
    admire: "Friend Request",
    income: "Earning",
    vote: "Vote",
    system: "System",
  },
};

const Empty = {
  emptyImage: "No Image",
  emptySearchImageTitle: "No related images found",
  emptySearchImageDesc:
    "Try different keywords. Using common keywords for generating images will yield better results.",
  emptySearchFilter: "No Filter for Current Search Type",

  friendList: {
    title: "No friends yet",
    desc: "Friends will be displayed here after you add them",
  },

  loginFirst: {
    moments: "Login to browse and post moments",
  },
};

const MateType = {
  original: "Original",
  fan: "Fanswork",
};

const Visibilities = {
  visibilityTitle: "Who can see this",
  public: "Public",
  private: "Private",
  onlyFollower: "Only Follower",
  onlyAdmire: "Only Admire",
  publicDesc: "Visible to all users",
  privateDesc: "Only visible to you",
  onlyFollowerDesc: "Only visible to followers of the current character",
  onlyAdmireDesc: "Only visible to your friends",
  status: {
    1: "Public",
    2: "Private",
    3: "Only Follower",
    4: "Only Admire",
    5: "Hidden",
    6: "Paid",
    7: "Senior Reader",
  },
};

const SidebarNavi = {
  home: "Home",
  discover: "Discover",
  conversation: "Chat",
  role: "Role",

  post: "Post",
  moment: "Moment",
  profile: "Profile",
  gallery: "Gallery",
  chat: "Chat",
  imageWorkshop: "Image Workshop",
  request: "Request",
  setting: "Setting",
  language: "Language",
  logout: "Logout",
  account: "Account",
  switch: "Switch",
  currentMate: "Current Mate",
  new: "New",
  clearCache: "Clear Cache",
  version: "Version",
  checkUpdate: "Check Update",
  timeline: "Timeline",
  downloadApp: "Download App",
  feedback: "Community / Social Media",
  wechat: "WeChat",

  joinGroupQrcode: "Join Group QR Code",
  joinGroupTip:
    "Long press to save to gallery, use WeChat to scan and join the group for communication.",
  appearanceSetting: "Appearance Setting",
  dark: "Dark",
  light: "Light",
  auto: "System",
  colorful: "Colorful",
  classic: "Classic",
  theme: "Theme",
  themeMap: {
    auto: "System",
    light: "闪亮の世界",
    dark: "暗夜の领域",
    cupcake: "萌系甜点",
    bumblebee: "蜂酱暴走",
    emerald: "翡翠梦境",
    corporate: "社畜模式",
    synthwave: "电子幻音",
    retro: "昭和回忆",
    cyberpunk: "赛博废土",
    valentine: "心跳告白日",
    halloween: "百鬼夜行",
    garden: "花の庭院",
    forest: "森の秘境",
    aqua: "水色幻想",
    lofi: "低保真废柴",
    pastel: "马卡龙物语",
    fantasy: "异世界入口",
    wireframe: "代码视界",
    black: "虚空吞噬者",
    luxury: "土豪金MAX",
    dracula: "血族契约",
    cmyk: "彩虹工厂",
    autumn: "枫叶物语",
    business: "社长办公室",
    acid: "迷幻剂警告",
    lemonade: "柠檬汽水",
    night: "夜猫子联盟",
    coffee: "社畜续命水",
    winter: "雪国列车",
  },

  selectSetting: "Select Setting on the left",
  stopImpersonate: "Stop Impersonate",
  beautify: "Beautify",
  creation: "Creation",
  playground: "Playground",
};

const setting = {
  selectSetting: "Select Setting on the left",
  account: "Account",
  appearance: "Appearance",
  language: "Language",
  preference: "Preference",
  chatTheme: "Chat Theme",
  about: "About",
  version: "Version",
  accountInfo: "Account Info",
  userName: "User Name",
  email: "Email",
  sensitiveContentPreference: "Sensitive Content Preference",
  phone: "Phone",
  bindEmail: "Bind Email",
  bindPhone: "Bind Phone",
  content: "Content",
  isBlockAiContent: "Is Block AI Content",
};

const Social = {
  followers: "Followers",
  admirer: "Admirer",
  following: "Following",
  admiring: "Admiring",
  likes: "Likes",
  liked: "Liked",

  admiringTitle: "No characters are currently being admired",
  admiringDesc: "No characters are currently being admired",
  admirerTitle: "No admires are currently available",
  admirerDesc: "This character currently has no admires",
  followingTitle: "No one is currently following this character",
  followingDesc: "No characters are currently being followed",
  followersTitle: "No followers at the moment",
  followersDesc: "No one is following this character yet",
  days: "days",
  you: "You",

  admirers: {
    guardingFor: "Admiring for",
    justGuarded: "just admired",
  },

  actions: {
    cancelGuarding: "Cancel admiring",
    deleteFriend: "Delete Friend",
  },
};

const MineMate = {
  post: "Post",
  profile: "Profile",
  gallery: "Gallery",
  chat: "Chat",
  imageWorkshop: "Drawing",
  paint: "Image Convert",
  request: "Request",
  setting: "Setting",
  language: "Language",
  task: "Task",
  story: "Story",
  game: "Game",
  gif: "Gif",
  portrait: "Feature",
  mutiImg: "Muti Image",
  storyVideo: "Story Video",

  tools: "Production Tools",
  queue: "Production Queue",
  create: "Creation and Publishing",
  earn: "Creation Income",
  profileSetting: "Profile Setting",
  createMate: "Create Mate",
};

const task = {
  type: ["Waiting", "Tagging", "High", "Ban"],
  btn: {
    high: "High Quality",
    img1: "Save to {chapter} Gallery",
    chapter: "Chapter",
    edit: "Edit",
    delete: "Delete",
    more: "More",
    gif: "Generate GIF",
    emoji: "Save as New Feature",
    emoji1: "Override Original Feature",
    info: "View Details",
    brush: "Redraw",
    image: "Expand",
    download: "Download HD",
    "eye-regular": "Switch to public display",
    "eye-slash": "Switch to private display",
  },
  deleteTip: "Auto delete after 15 days",
  status: {
    pending: "In Queue",
    processing: "Generating",
    timeout: "Network Timeout, Please Refresh and Retry",
  },
  tab: {
    All: "All",
    MateTrait: "Feature",
    StoryImage: "STI",
    StoryVideo: "Video",
    TextGif: "Gif",
    TextImage: "Drawing",

    ReplaceImageCharacter: "Replace",
    CreateMultiuserImage: "Create Multiuser Image",
  },

  createAIGenerationTask: "Create AI Generation Task",
};

const story = {
  publishedOn: "Published on",
  editOn: "Edit on",
  collectedOn: "Collected on",
  status: "Status",
  loadThreeMore: "Load three more chapters",
  new: "New",
  old: "Old",
  save: "Save",
  generate: "Generate",
  auto: "Automation",
  newStory: "New Story",
  editStory: "Edit Story",
  storyDescription: "Story Description",
  name: "Story Name",
  cover: "Story Cover",
  visibility: "Story Visibility",
  delete: "Delete Story",
  deleteDesc:
    "Delete the story and all its chapters. This action is irreversible. Are you sure you want to delete it?",
  processing: "Processing",
  generateTime: "Generate start time",
  generateTimeMinutes: "The generation time is approximately 1-2 minutes",
  waitTimeMinutes: "The waiting time is approximately 1-2 minutes",
  chapterGeneration: "Chapter content generation in progress",
  moreStory: "More stories from the author",
  read: "Read",
  readFullContent: "Click read view full content",
  wordCount: "Words",
  like: "Like",
  selectTheTypeChapterDownload: "Sselect th type of chaper download",
  image: "Image",
  info: "Info",
  createAt: "Create at",
  publishedAt: "Published at",
  author: "Author",
  generatingStory: "Generating story...",
  generatingStoryChapter: "Generating story chapter...",

  readMethod: "Read Method",
  viewVideo: "View Video",
  immersiveMode: "Immersive Mode",

  tab: {
    content: "Content",
    chapter: "Chapter",
    moment: "Moment",
    gallery: "Gallery",
  },
  base: {
    title: "Basic Information",
    type: "Type",
    edit: "Edit",
    addRole: "Add Role",
    summary: "Story Summary",
    relation: "Related Moments",
    add: "Add",
  },
  role: {
    title: "Story Characters",
    chapter: "Chapter Characters",
    add: "Add Role",
    my: "My Characters",
    admiring: "admiring",
    admire: "admire",
    select: "Select",
    1: "Protagonist",
    2: "Supporting Character",
  },
  style: {
    title: "Writing Style Reference",
    demo: "Writing Style Example",
    select: "Select from Existing Chapters",
  },
  g: {
    // Auto-generated
    title: "Auto-generated Content Reference",
    type: "Story Type",
    characterzz: "Story Characters",
    description: "Story Summary",
    momentIdzz: "Related Moments",
    exampleText: "Writing Style Example",
    beginning: "Chapter Beginning",
    previousStoryId: "Previous Chapter",
    ending: "Chapter Ending",
    cancel: "Cancel",
    basedPrev: "Based Prev",
    basedNext: "Based Next",
    basedContext: "Based Context",
    generatedFromMoment: "Generated from Moments",
    writingStory: "AI is writing a story...",
  },
  setting: {
    title: "Plot Settings",
    prevChapter: "Previous Chapter",
    select: "Select Previous Chapter",
    chapterStart: "Chapter Beginning",
    add: "Add Content Node",
    chapterEnd: "Chapter Ending",
    node: "Content Node",
    beginning: "Beginning",
    body: "Main Content",
    ending: "Ending",
  },
  type: {
    1: "Fantasy",
    2: "Science Fiction",
    3: "Adventure",
    4: "Mystery",
    5: "Thriller",
    6: "Crime",
    7: "Historical",
    8: "Biography",
    9: "Literary",
    10: "Romance",
    11: "Youth",
    12: "Humor",
    13: "Horror",
    14: "War",
    15: "Social Novel",
    16: "Family",
    17: "Psychological Novel",
    18: "Sci-Fi Horror",
    19: "Fantasy Adventure",
    20: "Historical Fantasy",
    21: "Mystery",
    22: "Fairy Tale",
    23: "Fantasy",
    24: "Short Story",
    25: "Realism",
    26: "Black Comedy",
    27: "Autobiography",
    28: "Fantasy Epic",
    29: "Mythology",
  },

  draft: "Draft",
  published: "Published",
  afterPosting5Update:
    "You can only create a story collection after posting 5 updates",
  storyChapter: "Story Chapter",
  selectStoryChapters: "Select Story Chapters",
  generateVideoText:
    "Select a story chapter, and AI will generate a video based on the chapter content.",
  generateIllustrationsText:
    "Select a story chapter and the AI will generate some illustrations based on the chapter contentSelect a story chapter and the AI will generate some illustrations based on the chapter content",
  narratorVoice: "Choose Narrator's Voice",
  aNarratorVoice: "Choose a voice for the narrator",
  backgroundMusic: "Atmosphere created by bgm",
  selectChapter: "Select a chapter",
  noChaptersAvailable: "No chapters available",
  noChapterAvailableYet: "No chapters available yet",
  currentStoryNoChapterCreatedYet:
    "The current story has no chapters created yet",
  currentCreatedChapters:
    "The current character has not created any chapters yet",
  selectVoice: "Select a voice",
  readBegin: "Read from the beginning",

  storyHalf: "You have ",
  storyFinal: "chapters not added to the story. Click to add.",
  ongoing: "Ongoing, currently at chapter ",
  ongoingTwo: "",

  newChapter: "New chapter",
  chapterEditing: "Chapter editing",
  chapterTitle: "Chapter Title",
  chapterDescription: "Chapter Description",
  chapterCover: "Chapter Cover",
  chapterCoverVideo: "Chapter Cover Video",

  separatorSymbol: "Separator",
  enterSeparatorSymbol: "Enter separator symbol",

  typePlaceholder: "Click to select type",

  totalWords: "Total {number} words",
  tellYourStory: "Tell your story...",

  insertImgMode: "Illustration",

  body: "Body",
  generated: "Generated",
  notGenerate: "Not Generated",

  imgText: "Image Text: ",
  video: "Video: ",
  visualNovel: "Visual Novel: ",

  chapterInfo: "Chapter Info",

  createVideo: "Create Video",
  createVisualNovel: "Create Visual Novel",

  immersiveRead: "Immersive Read",
  imgTextRead: "Image Text Read",
  chapterStart: "Chapter Start",
  chapterEnd: "Chapter End",
};

// 绘画
const painting = {
  individual: "Individual",
  multiplePeople: "Multiple People",
  iLike: "I like",
  custom: "Custom",
  selected: "Selected",
  prompt: "Prompt",
  global: "Global",
  people: {
    title: "Character",
    feature: "Character Feature",
    noFeatureInfo: "You haven't created any features yet.",
    noFeatureInfoDesc:
      "Creating features ensures that each generation is of the same character",
    new: "New",
    edit: "Edit",
    create: "GoCreate",
    beforeCreate: "After creating features, you can choose a {type} character",
    faceExpression: "Expression",
    pose: "Pose",
    poses: "Combined Poses",
    posePreset: "Preset",
    poseDiy: "Custom",
    newPoseDiy: "New Pose",
    poseSelect: "Pose Illustration",
    select: "Select Reference Image",
    upload: "Upload Reference Image",
    uploadPose: "Upload",
    clothing: "Clothing",
    import: "Import from Wardrobe",

    position: "Focus Area",
    position1: "Full Body",
    position2: "Face",
  },
  layout: {
    title: "Ref Image",
    img: "Layout Ref Image",
    upload: "Upload Layout Ref Image",
    weight: "Reference Image Weight",
    pose: "Pose Reference Image",
  },
  origin: {
    title: "Original Image",
    upload: "Upload Image",
    weight: "Reference Image Weight",
  },
  env: {
    title: "View & Env",
    desc: "Environment Description",
    import: "Import from Scene Package",
  },

  single: {
    selectCharacter: "The character feature has not been selected yet",
  },
  muti: {
    addMate: "Add Role",
    selectMate: "Select Mate",
    selectTrait: "Select Feature",
    selectCharacter: "At least two characters need to be selected",
    noGirlOrBoyTips:
      "Character {name} does not have gender-specific cue words. It is recommended to add 1girl or 1boy cue words to ensure proper generation of images.",
    continue: "Continue Generating",
  },
  replace: {
    title: "Replace Image",

    selectCharacter: "The feature to replace with has not been selected yet",
    selectImage: "The image to replace has not been uploaded yet",
  },
  replaceWith: {
    title: "Replace With",
  },
  emoji: {
    selectImage: "The original image has not been uploaded yet",
    inputPrompt: "The expression prompt word has not been entered yet",
  },
  setting: "Generation Settings",
  pages: "Number of Images",
  proportion: "Ratio",
  numberGeneratedImages: "Number of Generated Images",

  featuresCueWord: "Features & Cues.",
  englishCueWords: "English Cue Words",
  enterEnglishCueWordsText: "Enter English cue words, separated by commas.",
  // 表情
  style: {
    title: "Art Style",
    preset: "Platform Preset",
    custom: "Custom Tag",
    select: "Select Style",
    selectTip: "Enable Fusion Seal for Multiple Selections",
    mixSetting: "Fusion Setting",
    styleId: "Style ID",
    consistency: "Consistency",
    modelVersion: "Model Version",

    mixSettingError: "The sum of fusion ratios must be 1",
    must2: "Select up to 2 art styles for fusion",
  },

  switchMuti: "Switch to Multiplayer",
  switchSingle: "Switch to Single Player",

  poses: {
    "stand by stand": "Stand By Stand",
    kiss: "Kiss",
    hug: "Hug",
  },

  nsfwNotice:
    "nsfw currently only supports custom art styles, and the art style has been adjusted to v2 (suitable for derivative works)",

  envIsNsfwCannotCloseNsfw:
    "The Layout Ref contains sensitive information and cannot disable nsfw. Please delete it and try again.",
  originIsNsfwCannotCloseNsfw:
    "The original image contains sensitive information and cannot disable nsfw.",

  traitType: {
    preset: {
      title: "Preset (Suitable for Newbie AI Artists)",
      titleSimple: "Preset",
      content:
        "Search for your favorite anime characters and save them as your own character feature. You can then easily call these 2D character feature to generate more images or videos.",
    },
    text: {
      title: "Text-based Feature",
      content:
        "You can enter any prompts to generate 2D character feature. You can then easily call these 2D character feature to generate more images or videos.",
    },
    img: {
      title: "Image-based Feature",
      content:
        "You can upload images/photos of any character to generate 2D character feature. You can then call these character feature to generate more images or videos.",
    },
    mix: {
      title: "Mixed (Suitable for Deep AI Artists)",
      content:
        "You can enter any prompts + images/photos and control the blending weights. Suitable for deep AI creators.",
    },
  },

  paintType: {
    text: {
      title: "Text-based Images",
      content: "You can enter any prompts to generate images",
      single: "Single",
      multi: "Multi",
      nobody: "Nobody",
    },
    img: {
      title: "Image-based Images",
      content:
        "You can upload any reference image and transform it into your favorite anime style, or replace the characters with your favorite anime characters",
      repaint: "Repaint",
      replace: "Replace",
      emoji: "Emoji",
    },
    mix: {
      title: "Mixed Images",
      content:
        "You can enter any prompts + images/photos and control the blending weights, suitable for AI deep creators",
      name: "Mixed",
    },
  },

  promptUpdate: {
    title: "Refine Prompts",
    origin: "Original Prompts",
    new: "New Prompts",
    confirmReplace:
      "Confirm replacing the original prompts with the new prompts?",
    regenerate: "Regenerate",
  },

  styles: {
    "3D graphics": "3D graphics",
    cinematic_lighting: "cinematic lighting",
    "magazine cover": "magazine cover",
    "4koma": "4-panel comics",
    "comic book": "comic book",
    "marker_(medium)": "medium marker",
    Impasto: "Impasto",
    futurism: "futurism",
    monochrome: "monochrome",
    "Polaroid art": "Polaroid art",
    "genshin impact": "Genshin Impact",
    "pixel art": "pixel art",
    "Studio Ghibli": "Studio Ghibli",
    "glowing neon lights": "glowing neon lights",
    "rebecca (cyberpunk)": "Rebecca (cyberpunk)",
    "alphonse mucha": "Alphonse Mucha",
    goth: "goth",
    "retro_arf style": "retro art style",
    "art nouveau": "Art Nouveau",
    lens_flare: "lens flare",
    silhouette: "silhouette",
    "azur lane": "Azur Lane",
    light_rays: "light rays",
    "vibrant colors": "vibrant colors",
    backlighting: "backlighting",
    lineart: "lineart",
    watercolor: "watercolor",
  },
};

const Request = {
  pendingReview: "Pending Review",
  reviewed: "Reviewed",
  pendingTaReview: "Pending Ta's Review",
  taReviewed: "Ta Reviewed",
  applyGuardYou: "Apply to be your friend",
  applyGuard: "Friend Request",
  reviewTime: "Review Time",
  status: {
    approved: "Approved",
    rejected: "Rejected",
  },
};

// Feature
const trait = {
  traitPreview: "Feature Preview",
  positive: "Positive",
  negative: "Negative",
  feature: {
    extraction: "Feature Extraction",
    selected: "Selected Labels",
    description: "Feature Description",
    clone: "Clone",
  },
  image: "Image for Extraction",
  select: "Select Image",
  reselect: "Reselect",
  copy: "Copy Prompt Words",
  import: "Import from Other Characters",
  new: "Create",

  tab: {
    artStyle: "Art Style",
    img: "Reference Image",
    descriptors: "Descriptors",
  },
  edit: {
    title: "Character Feature",
    clone: "Clone Feature",
  },

  random: "Random",
  characterImage: "Character Image",
  generatePreview: "Generate Preview",
  traitName: "Feature Name",
  traitDescription: "Feature Description",
  showPromptWords: "Show Prompt Words",
  traitCover: "Feature Cover",
  changeCover: "Change Cover",
  autoPrompt: "Automatically parse images and append them to prompt words",

  description: "Description",
  expression: "Expression",
  placeholder: "Please select or enter prompt words...",

  tagAction: {
    weight: "Weight",
    labelWeight: "Swipe left to delete weight",
  },

  setWeight: "Set Weight",
  delete: "Delete",
  done: "Done",

  artStyleTitle: "Please choose a style you like",

  mode: {
    preset: "Preset Feature (Fans Creations)",
    custom: "Custom Feature (Original Creation)",
    0: "v0 (Mixed Model)",
    1: "v1（Original Creation）",
    2: "v2（Fans Creations）",
  },
};

const Cell = {
  willReduceMessage: "Will reduce similar messages",
  himWillAlsoMessage: "Mate will also forget this message",
  himMemoryWillModified: "Mate's memory will also be modified",
  basicInformation: "Basic Information",
  photograph: "Photograph",
  interest: "Interest",
  useAiDrawing: "Use AI for Drawing",
  useAiDrawingEmoji: "Use AI to Draw Emojis",
  upload: "Upload",
  image: " Image",
  video: " Video",
  characterSelect: "Select from Character Gallery",
  generatedImage: "Select from Generated Images",
  chapterSelect: "Select from Chapter Images",
  portraitsSelect: "Select from Portraits",
  animationSelect: "Select from Animation",
  characterAlbum: "Character Gallery",
  aiDrawing: "AI Drawing",
  chapterAlbum: "Chapter Gallery",
  cancel: "Cancel",
  useAvatar: "Use Avatar",
  editMoment: "Edit Moment",
  deleteMoment: "Delete Moment",
  editReply: "Edit Reply",
  deleteReply: "Delete Reply",
  deleteCollectionItem: "Delete Collection Item",

  delete: "Delete",
  report: "Report",
  blockUser: "Block User",

  creatorType: "Creator Type",
  model: "Model",
  lastUpdatedTime: "Last Updated Time",
  notSet: "Not Set",
  likingCount: "Likes Received",
};

const bgm = {
  happy: "Happy and Cheerful",
  sad: "Sad",
  angryIntense: "Angry and Intense",
  fearfulAnxious: "Fearful and Anxious",
  gentleSoothing: "Gentle and Soothing",
  exciting: "Exciting",
};

const Moment = {
  items: "Items",
  selected: "Selected",
  countMoments: " moments",
  noSelectedMoment: "No Selected Moment",
  viewAllContent: "view all content",
  collaborativeCreation: "Collaborative Creation",
  character: "Character",
  moment: "Moment",
  expression: "Expression",
  setting: "Setting",
  todayHappened: "What happened today?",
  sync: "Sync",
  syncWorldviewTimeline: "Sync OC's Worldview Timeline",
  syncMateTimeline: "Sync OC's Timeline",
};

const game = {
  processing: "Processing",
  producer: "Producer",
  selectGame: "Select Game",
  audioName: "Audio Name",
  name: "Name",
  recommendation: "Recommended",
  selectContentNode: "Select Content Node",
  jumpAnotherNode: "Jump to Another Node",
  pleaseSelectDialogue: "Please select the dialogue to jump to",
  notSet: "Not Set",
  modify: "Modify",
  createNewGame: "Create New Game",
  jumpToSettings: "Configure Jump",
  playerResponse: "Player Response",
  newGames: "New Games",
  author: "Author: ",
  playTimes: "Play Times",
  auto: "Auto generated",
  player: "Player",
  characterIntro: "Character Introduction",
  gameType: "Game Type: ",
  version: "Version: ",
  toGameDetailPage: "Go to Game Detail Page",
  videoAndScreenshot: "Game Video and Screenshot",
  notSetJump: "Not Set Jump",
  tab: {
    title: "Basic Information",
    endings: "Endings",
    setting: "Plot Settings",
  },
  base: {
    title: "Basic Information",
    name: "Name",
    type: "Game Type",
    description: "Game Description",
    characterzz: "Participating Mates",
    characterIntro: "Self Introduction",
    player: "Player Role",
    playerName: "Player Name",
    playerAvatar: "Player Avatar",

    playerIntro: "Character Introduction",
    cover: "Game Cover Image",
    edit: "Edit",
    backgroundMusic: "Background Music",
    introduction: "Introduction",
    selectCharacter: "Select Participating Mate",
  },
  role: {
    0: "All",
    1: "MC",
    2: "SC",
    3: "Player",
    4: "Narrator",
  },

  roleTab: {
    my: "My Characters",
    myGuarded: "My Admired",
    guardians: "Admiring",
  },

  toneMood: {
    1: "Angry",
    2: "Happy",
    3: "Sad",
    4: "Fearful",
    5: "Gentle",
    6: "Excited",
    9: "Custom",
  },
  ending: {
    title: "Endings",
    add: "Add Ending",
  },
  updateLog: {
    title: "Update Log",
    current: "Current Version",
    later: "Updated Version",
    content: "Update Content",
    version: "Version History",
  },
  node: {
    conversation: "Conversation",
    conversationEdit: "Edit Conversation",
    conversationCount: "Number of Conversations: ",

    connect: "Connect Plots",
    connectEdit: "Edit Connection",
    enter: "Enter Current Node",
    condition: "Entry Condition:",
    trigger: "Trigger Condition：",
    to: "Go to Node",
  },
  type: {
    1: "Romance",
    2: "Survival",
    3: "Exploration",
  },

  actions: {
    playAudio: "Play Audio",
    renewAudio: "Renew Audio",
    editAudio: "Edit Audio",
    removeAudio: "Remove Audio",
    editImage: "Edit Image",
    removeImage: "Remove Image",
    cancel: "Cancel",
  },

  // 模块辅助模块
  gamePlaza: "Game Plaza",
  myCreations: "My Creations",
  romanceGenre: "Romance Genre",
  createScriptText: "Haven't created a game yet? Go ahead and create one now!",
  releaseText: "You haven't released a game yet. Go ahead and release it now!",
  unreleased: "Unreleased",
  released: "Released",

  pleaseEnterGameName: "Please enter the game name",
  typePlaceholder: "Click to select type",
  clickChooseBackgroundMusic: "Click to choose bgm",
  chooseBackgroundMusic: "Choose bgm",
  noBackgroundMusic: "No bgm",

  beginning: "Beginning",
  plotNode: "Plot Node",
  nodeId: "Node ID",
  score: "Score",
  connected: "Connected",

  plotPoint: "Plot Point",
  activationCondition: "Activation Condition",
  copyToCurrentCanvas: "Apply to Current Canvas",

  unnamedNode: "Unnamed Node",
  noImage: "No Image",
  noDialog: "No Dialog",
  noSelectedDialog: "No Selected Dialog",

  pleaseInputDialog: "Dialog Content",
  dialogLimitTip:
    "If the text exceeds two lines or exceeds the character limit, the excess portion may be hidden in the game.",
  lineLimit: "Line Limit",
  charLimit: "Character Limit",
  row: "row",

  static: {
    end: "Ending",
    character: "Role",
    image: "Image",
    audio: "Audio",
    word: "Word",
  },

  show: {
    title: "Show Settings",
    defaultTone: "Default Tone",
    reselect: "Reselect",
    viewAllDialog: "View All Dialogs",
    allDialog: "All Dialogs",
    resetTone: "Reset Tone",
    unselected: "Unselected",
    selectTone: "Select Tone",
  },

  showUpCharacters: "Show Up Characters: ",
  viewConversation: "View Conversation",
  audioManager: "Audio Manager",

  values: {
    // Numeric settings
    title: "Numerical setting",
    people: "character value",
    other: "Other values",
    tips: "You can add or delete characters in <span class='text-primary'>Performance Settings</span>. After displaying and adding values, you can set the values in the game.",
    show: "Show",
    add: "Add value",
    name: "name",
    nameTip: "Number name",
    init: "initial value",
    initTip: "An integer between -100 ~ 100",
    desc: "Description",
    descTip: "Numerical introduction",

    //Connect node conditional statement
    condition: "Conditional Statement",
    operation: "Operator",
    and: "And",
    or: "or",
    greater: "greater than",
    less: "less than",
    greaterEqual: "greater than or equal to",
    lessEqual: "less than or equal to",
    equal: "equal to",
    notEqual: "not equal to",

    deleteTitle: "Delete the value?",
    rule: {
      name: "Please enter a name",
      initScore: "Please enter an initial value",
    },

    conditionFormatError: "Conditional statement format error",
    tip: `Tip: First select the value of the character or game, then directly click the greater than, less than, greater than or equal to, or less than or equal to operator, and finally enter the value. Use "and" or "or" to connect multiple conditions.`,
    empty: "Value not added yet",
  },

  fromStory: "Import from Story",
  fromText: "Import from Text",
};

const Payment = {
  title: "Earnings",
  deposit: "Deposit",
  balance: "Balance",
  income: "Income",
  expenditure: "Expenditure",
  incomeRecord: "Income Record",
  myRoleIncome: "My Role Income",
  originContent: "Original Content",
  fee: "Platform Fee: ${platformFeeAmount}",
  type: {
    tip: "Contributed",
    admireSubscriptionFee: "Contributed",
    mediaOrder: "Contributed",
  },
  leaveMessage: "and left a message",

  bindPaypal: "Bind Paypal Account",

  inputPaypalAccount: "Please enter Paypal account",
  confirmPaypalAccount: "Confirm Paypal account again",
  notHasPaypal: `Don't have a Paypal account? <a class="text-primary" href="https://www.paypal.com/c2/welcome/signup/#/mobile_conf" target="_blank">Register</a>`,
  accountNotMatch: "The two accounts do not match",

  withdraw: "Withdraw",
  withdrawRecord: "Withdrawal Record",
  tips: "After submitting the request, it is expected to arrive in your Paypal account within 1-3 hours",
  withdrawing: "Withdrawing",
  withdrawStatus: {
    1: "Withdrawing",
    2: "Withdrawal Successful",
    3: "Withdrawal Failed",
  },

  currentAccountBalance: "Current Account Balance",
  useableBalance: "Usable Balance",
  freeze: "Frozen Amount",
  freezeTip:
    "The settlement amount is the earnings from the previous month. Earnings before the 15th of this month will be frozen. They will automatically be unfrozen on the 16th of this month.",
  nextAutoPayTime: "Next Auto Payment Time",
  payTip:
    "Note: Each payment through Paypal incurs a transaction fee ranging from $0.25 to $20 (depending on your Paypal account location). Therefore, it is recommended to increase the minimum auto payment amount to reduce fees.",
  settingMinAmount: "Set Your Minimum Auto Payment Amount",
  minAutoWithdrawal: "Minimum Auto Payment Amount",
  autoTip:
    "If the current account balance for this period is less than the minimum auto payment amount, it will be accumulated for settlement in the next month.",
  nextAutoWithdrawAmount: "Next Auto Payment Amount",
  containPaypalFee: "(Paypal Fee: ${amount})",

  withdrawToPaypal: "Withdraw to Paypal Account",
  replaceBind: "Replace Binding",
  withdrawAmountEmpty: "Please enter the withdrawal amount",
  withdrawAmountMin: "Withdrawal amount must be greater than 1",
  withdrawAmountNotEnough: "Insufficient balance",

  recent: {
    day: "Last 3 days",
    week: "Last week",
    month: "Last month",
  },
  success: "Successfully Purchased",
  subscribed:
    "Congratulations, you have successfully subscribed to the <b class='text-primary'>{type}</b> version",
  paymentChecking: "Checking payment result...",

  chatList: "Chat List",
  unlockImage: "Unlock Image",
  expireAt: "Expire at",
};

const ReloadPrompt = {
  offline: "App ready to work offline",
  hasUpdate: "New content available, click on reload button to update.",
  reload: "Reload",
  later: "Close",
};

const Home = {
  home: "Home",
  interaction: "Interaction",
  discover: "Discover",
  mine: "Mine",
  createNew: "Create a new OC now!",
  advanced: "Advanced Creation",
  ocCreator: "OC Editor",
  original: "Original Characters",
  fanswork: "Fan Characters",
  game: "Game",
  hot: "Hot",
  hotImage: "Hot Image",
  hotReplacement: "Hot Replacement",
  latest: "Latest",
  storyVideo: "Story Video",
  like: "You may also like",
  type: {
    1: "Character",
    2: "Moment",
    3: "Story",
    4: "Game",
    Original: "Original Characters",
    Fanswork: "Fan Characters",
  },
  more: {
    character: "More Characters",
    game: "More Games",
    story: "More Stories",
  },
  menu: {
    edit: "Workshop",
    chat: "Chat",
    painting: "Painting",
  },

  OC: {
    residentCount: "OC Residents: {count}",
    runtime: "Running Time: {runtime}",
    wordCount: "Word Count: {wordCount}",
    mediaCount: "Media Count: {mediaCount}",
    momentCount: "Moment Count: {momentCount}",
    storyCount: "Story Count: {storyCount}",
    thingsCount: "Item Count: {thingsCount}",
    taskCount: "Task Count: {taskCount}",
    OCResident: "{name}'s OC Residents",
    noMates: "No OC Residents",
    addMate: "+OC Resident",
    addMateFromCurrentWorldview: "Add Existing OC to Current Planet",
    addMateFromNew: "Create New OC",
  },
  planet: {
    timeline: "{name} Timeline",
  },
};

const Animation = {
  insert: "Insert animation",
  name: "Name",
  keyframe: "Keyframe",
  preview: "Animation Preview",
  verticalPainting: "Vertical Painting",
  notSet: "Not Set",
  list: "Animation List",
  creation: "Animation creation",
  blink: "Blink animation",
  lipSync: "Lip sync animation (under development...)",
  btn: {
    create: "Create animation",
  },

  type: {
    blink: "Blink",
    lipSync: "Lip Sync",
  },
  portraitType: {
    openEyes: "Open Eyes",
    closeEyes: "Close Eyes",
    openMouth: "Open Mouth",
    closeMouth: "Close Mouth",
    halfOpenMouth: "Half Open Mouth",
  },
};

const Config = {
  seconds: "s",
};

const Coin = {
  coin: "Coin",
  getCoin: "Get Coin",
  goGetRecordsView: "Get Records",
  dailyTask: "Daily Task",
  oneTimeTask: "One-time Task",
  residentTask: "Resident Task",
  reward: "Reward",
  community: "Community Activity",
  dailyTaskLimit: "Daily Coin Acquisition Limit",
  dailyCheck: "Check-in",
  dailyChecked: "Checked-in Today",
  postReactionTask: "Post 5 Reactions",
  reviewTask:
    "Review different works and receive a response from the author of at least 10 characters",
  moreTask: "More Tasks",
  bioTask: "Complete a character's bio (at least 33 words)",
  updateAvatarTask: "Update a character's avatar",
  coinUsageIntroTitle: "What are Coins Used for?",
  goldTicketIntroTitle: "What are Gold Tickets Used for?",
  coinUsageIntroDesc:
    "Coins are earned within the Anymate community and can be used to purchase upvotes. Upvotes can be cast on Monthly Leaderboard Activity for content you like.",
  getCoinIntroTitle: "How can you get Coins?",
  getCoinIntroDesc:
    "Users can earn coins by being active daily in the community, purchasing premium content, tipping, or participating in other community activities.",
  checking: "Checking...",
  coinRecords: "Coin Records",
  incomeRecord: "Acquisition Records",
  incomeRecordEmpty: "No acquisition records yet",
  expenditureRecord: "Expenditure Records",
  expenditureRecordEmpty: "No expenditure records yet",
  voted: "Voted",
  buyTicket: "Buy Ticket",

  voteIncentive: "Vote Incentive",
  ticket: "Ticket",
  noEnoughCoin: "Insufficient Coins",
  insufficientGoldTickets: "Insufficient Gold Tickets",
  ticketNum: "Tickets",
  goldTicketNum: "Gold Tickets",
  inputTicketNum: "Please enter the number of tickets",
  leaveMessage: "Leave a Message",
  consumptionCoins: "Consumption",
  restCoins: "Remaining Coins",
  buyTicketsAndVote: "Exchange and Vote",
  howManyTicketsToVote:
    'How many tickets do you want to vote for <span class="text-base-content">{name}</span>?',
  donate: "Donate Incentive",
  howMuchMoneyToDonate:
    'How many crystals do you want to donate to <span class="text-base-content font-bold">{name}</span>?',
  amount: "Amount",
  inputAmount: "Please enter amount",
  anonymousVote: "Anonymous Vote",
  anonymousUser: "Anonymous User",
  voteRecords: "Vote Records",
  anonymousVoteLimit:
    "Anonymous voting requires a message of at least 10 words",
  todayRestVotingCount: "Today's Remaining Exchangeable Ticket Count",
  overTodayRestVotingCount: "Exceeding Today's Exchangeable Ticket Limit",
  vote: "Vote",
  goldTicket: "Gold Ticket",
  regularTicket: "Regular Ticket",
  getGoldTicket: "Get Gold Ticket",
  goldTicketRules: goldTicketRules,
  goldTicketVoteLimit:
    "Using Gold Votes requires a comment of 200 words or more",

  identity: "Identity",
  seniorReader: "Senior Reader",
  regularReader: "Regular Reader",
  applySeniorReader: "Apply for Senior Reader",
  reasonForApplication: "Reason for Application",
  bodyOfText: "Body of Text",
  seniorReaderRules: seniorReaderRules,
  applicationSubmitted:
    "Your application has been submitted. We will inform you of the review result through email and in-site notification.",
  applicationApproved: "Congratulations, your application has been approved.",

  give: "After voting, You will receive ",
};

const rank = {
  ranking: "Ranking",
  leaderboard: "Leaderboard",
  rank: "Leaderboard",
  mostPopularRank: "Most Popular Leaderboard",
  updateTime: "Last Updated",
  firstHalf: "First Half",
  secondHalf: "Second Half",
  noWorkOnRank: "No {name} on the leaderboard yet",
  noWorkOnRankDesc:
    "Vote for {name} to get your favorite ones on the leaderboard",
  noMateOnRank: "No characters on the leaderboard yet",
  noMateOnRankDesc:
    "Vote for characters to get your favorite ones on the leaderboard",
  noGameOnRank: "No games on the leaderboard yet",
  noGameOnRankDesc:
    "Vote for games to get your favorite ones on the leaderboard",
  noStoryOnRank: "No stories on the leaderboard yet",
  noStoryOnRankDesc:
    "Vote for stories to get your favorite ones on the leaderboard",
  comments: "Comments",
  rankOfCurrentMonth: "Rankings of Current Month",
  notRanked: "Not Ranked",
  contentHome: "Content Home",
  mateHome: "Mate Home",
  getVotesCount: "Votes",
  pastRankings: "Past Rankings",
  historyLeaderboard: "History Leaderboard",
  currentLeaderboard: "Current Leaderboard",
  rules: "Rules",
  leaderboardRulesExplanation: "Leaderboard Rules Explanation",
  rankRulesContent: rankRules,
  onGoing: "Ongoing",
  concluded: "Concluded",
};

const collection = {
  name: "Collection",
  window: "Collection",
  no: "No collections yet",
  my: "My Collections",
  title: "Title",
  titleDesc: "Collection title",
  summer: "Summary",
  summerDesc: "Collection summary",
  inviteCreator: "Invite Collaborators",
  addCreator: "Add Collaborators",
  know: "Learn about Collaborative Collections",
  join: "Join Collection",
  select: "Select Collection",
  create: "Create Collection",
  edit: "Edit Collection",
  none: "No Collection Selected",

  cover: "Collection Cover",
  isPublic: "Is Public",

  visibility: {
    1: "Public Collection",
    2: "Private Collection",
  },

  addContent: "Add Content",
  addMoment: "Add Moment",
  addStory: "Add Story",
  addGame: "Add Game",
  author: "Collection Author",
  count: "{momentCount} Moments {storyCount} Stories {gameCount} Games",

  all: "All",
  moment: "Moments",
  storyBook: "Stories",
  galGame: "Games",

  deleteParticipant: "Delete Collaborator",
  deleteParticipantDesc: "Are you sure you want to delete this collaborator?",
  feedback: "Feedback({count})",
  collectionTime: "Collection Time:",
  c_pTime: "Collection & Publish Time:",
  publishTime: "Publish Time:",

  collectionAsc: "Earliest Collection",
  collectionDesc: "Latest Collection",
  authorSort: "Author Sort",
  publishAsc: "Earliest Publish",
  publishDesc: "Latest Publish",

  mode: {
    edit: "Edit Mode",
    view: "View Mode",
  },

  resetOrder: "Reset order",
};

const share = {
  name: "Share",
  title: "Share with Friends",
  moment: "Moment",
  copyLink: "Copy Link",
  shareProfile: "Share Profile",
  shareWithLink: "Share with Link",
};

const contactUs = {
  contactUs: "Contact Us",
  needHelp: "Encountering issues or need assistance?",
  joinCommunity: "Join User Community",
  emailUs: "Email Us",
  deleteAccountInstruction: `If you want to delete your account:
<ol>
  <li>You need to first log in to your Anymate account</li>
  <li>Go to your <a href="/mate/mine" target="_blank">Character Profile</a></li>
  <li>Click on the character edit <span class="iconify mingcute--edit-3-line" /> button</li>
  <li>Click on Visibility in the sidebar</li>
  <li>Click on delete account</li>
</ol>
Follow the prompts to complete the account deletion process.`,
};

const nsfw = {
  contentRating: "Content Rating",
  nsfw: "NSFW",
  sfw: "SFW",
  noLimit: "No Content Rating Limit", //不限制内容评级
  isNsfw: "This content is NSFW",
  age: {
    title: "Age Verification",
    content:
      "The following content contains age-restricted materials including nudity and explicit depictions of sexual activity. Before entering, you affirm that you are at least 18 years of age or the age of majority in the jurisdiction you are accessing the website from and you consent to viewing sexually explicit content.",
    enter: "I am 18 or older - Enter",
    exit: "I am under 18 - Exit",

    welcome: "Welcome to Anymate!",
    rules: "Rules:",
    rules1: "No hate speech",
    rules2: "No Sexualized minors",
    rules3: "No incest content",
    oldThan18: `I'm 18 years or older`,
    enterAnymate: "Enter Anymate",
  },

  img: {
    title: "Sensitive Content",
    content: `This content may be sensitive to some users. You must be 18 or older to view this content. `,
    view: "view",
    unlock: "Unlock entire picture",
  },

  cnBan:
    "Due to relevant laws and regulations in mainland China, viewing this content is currently not supported for users in mainland China or Chinese users.",

  ageBan:
    "Due to being under 18 years old, viewing this content is currently not supported for you.",
  iosBan:
    "Due to restrictions on the iOS system, viewing this content is currently not supported for iOS users.",

  cnPayBan:
    "Due to relevant laws and regulations in mainland China, purchasing this content is currently not supported for users in mainland China or Chinese users.",
  sensitiveContent: "Sensitive Content",
  sensitiveContentDesc:
    "This content may contain sensitive material. You need to login and\n" +
    "        verify your age to view this content.",
};

const purchase = {
  name: "Purchase",
  get: "Get",
  crystal: {
    notEnough: "Sorry, you don’t have any Love Crystals",
    notEnough2:
      "Sorry, you do not have enough Love Crystals, please purchase more.",
    buy: "Buy more Love Crystals",
    buyMore: "Buy more",
    current: "Current Love Crystals",
    tips: "Love Crystals can be used to purchase or generate unlimited content",
    name: "Love Crystals",
    confirm: "Confirm your request",
    matePrompt: "Mate Prompt",
    amount: "Generated amount",
    autoAddTag: "Auto add NSFW tags to generate",
    cost: "cost",
    try: "Try for free",
    exchange: "Exchange {amount}",
  },

  swap: {
    powerConfirm: `Are you sure you want to exchange {crystal} Love Crystals for {power} Power Coins?`,
  },

  power: {
    current: "Current Power Cube",
    name: "Power Cube",
    notEnough2:
      "Sorry, you don’t have enough Power Cubes, please purchase first.",
    content:
      "When using the function of generating Images and Chat to Mate, the power cube will be consumed.",
    notEnough: "Sorry, you don’t have enough Power Cubes",
    buy: "Buy more Power Cubes",
    otherWaysToObtain: "Other ways to obtain Power Cubes",
  },

  premium: {
    title: "Premium Content",
    content: `This content needs to be subscription of mate to view`,
    view: "view",
  },

  miss: {
    name: "Miss",
    crystal:
      "It is recommended to recharge ${amount} to purchase this item, you will receive",
    power: `You can use <img src="/img/pay/crystal.webp" alt="" class="icon-base" /> {crystal} to exchange <img src="/img/pay/power-cube.webp" alt="" class="icon-base" /> {power}`,
    other: "Other Amount",
  },

  chineseBan:
    "Due to relevant laws and regulations in mainland China, the purchase of Love Crystals is currently not supported for users from mainland China or Chinese users.",

  setting: {
    paid: "Paid Setting",
    free: "Free",
    oneTime: "Paid To View",
    min: "Min paid fee is",
    premium: "Premium Subscription",

    freeToView: "Free to view",
    oneTimeToView: "Pay of {amount} crystal to view",
    premiumToView: "Premium subscription required to view",
    oneTimeOrPremium:
      "One-time payment of ${amount} or premium subscription required to view",
  },

  item: {
    unlock: "This resource is not unlocked yet",
    unlockDesc: "You can unlock this resource in the following ways",
    pay: "Purchase separately",
    sub: "Premium Subscribe",
    subscription: "Subscribe to premium to unlock more resources",
    chat: "Chat Unlock",
  },

  sub: {
    title: "Subscription",
    desc: `Please make sure you have registered a email account that matches the one used with Anymate.If you have any questions, please `,
    monthly: "Monthly",
    annually: "Annually",
    subscribe: "Subscribe",
    subscribed: "Subscribed",
    subscribedTip:
      "Each subscription is independently timed and billed. You will receive corresponding crystals upon renewal. If you only want to keep one subscription, please manually close it on the management page.",
    add: "Add Subscription",
    change: "Change Subscription",
    current: "Current Plan",
    month: "Month",
    year: "Year",
    tryFree: "Try for free",
    trial: "Trial",
    free3days: "3 days",
    payByMonth: "Pay monthly",
    payByYear: "Pay yearly",
    save: "Save",
    canceling: "Canceling subscription",
    cancelSuccess: "Subscription canceled successfully",
    cancelFail: "Failed to cancel subscription",
    popular: "Most Popular",
    active: "Active",
    expireDate: "Will automatically cancel on {date}",
    1: {
      title: "Free",
      profits: [
        "4K memory",
        "Create custom characters",
        "Access community characters",
        "Multi-language translation",
      ],
      ban: [
        "Chat message audio",
        "Memory deleted after 14 days of inactivity",
        "Change relationship",
      ],
    },
    2: {
      title: "Starter",
      priceMonth: "7.99",
      priceMonthYearly: "6.79",
      profits: [
        "All features of the Free Plan",
        "60 Crystals(Worth $10) per month",
        "Up to 16K memory",
        "Chat continue function",
        "Chat message audio",
        "Change memory without Crystal",
      ],
      ban: ["Load chat scene", "Change relationship"],
    },
    3: {
      title: "Premium",
      priceMonth: "17.99",
      priceMonthYearly: "15.29",
      profits: [
        "All features of the Standard Plan",
        "200 Crystals(Worth $34) per month",
        "Up to 32K memory",
        "Chat reply options",
        "Chat scene loading",
        "Change relationship",
        "Custom relationship prompt",
      ],
    },
    4: {
      title: "Deluxe",
      priceMonth: "49.99",
      priceMonthYearly: "42.49",
      profits: [
        "All features of the Premium Plan",
        "700 Crystals(Worth $119) per month",
        "Up to 64K memory",
      ],
      star: [
        "Private Discord Channel",
        "Early Access New Feature",
        "Exclusive Avatar Frame",
      ],
    },
  },
};

const translate = {
  selectTranslateLanguage: "Select Translation Language",
  lang: {
    Albanian: "Albanian",
    Amharic: "Amharic",
    Arabic: "Arabic",
    Armenian: "Armenian",
    Bengali: "Bengali",
    Bosnian: "Bosnian",
    Bulgarian: "Bulgarian",
    Burmese: "Burmese",
    Catalan: "Catalan",
    Chinese: "Chinese",
    Croatian: "Croatian",
    Czech: "Czech",
    Danish: "Danish",
    Dutch: "Dutch",
    English: "English",
    Estonian: "Estonian",
    Finnish: "Finnish",
    French: "French",
    Georgian: "Georgian",
    German: "German",
    Greek: "Greek",
    Gujarati: "Gujarati",
    Hindi: "Hindi",
    Hungarian: "Hungarian",
    Icelandic: "Icelandic",
    Indonesian: "Indonesian",
    Italian: "Italian",
    Japanese: "Japanese",
    Kannada: "Kannada",
    Kazakh: "Kazakh",
    Korean: "Korean",
    Latvian: "Latvian",
    Lithuanian: "Lithuanian",
    Macedonian: "Macedonian",
    Malay: "Malay",
    Malayalam: "Malayalam",
    Marathi: "Marathi",
    Mongolian: "Mongolian",
    Norwegian: "Norwegian",
    Persian: "Persian",
    Polish: "Polish",
    Portuguese: "Portuguese",
    Punjabi: "Punjabi",
    Romanian: "Romanian",
    Russian: "Russian",
    Serbian: "Serbian",
    Slovak: "Slovak",
    Slovenian: "Slovenian",
    Somali: "Somali",
    Spanish: "Spanish",
    Swahili: "Swahili",
    Swedish: "Swedish",
    Tagalog: "Tagalog",
    Tamil: "Tamil",
    Telugu: "Telugu",
    Thai: "Thai",
    Turkish: "Turkish",
    Ukrainian: "Ukrainian",
    Urdu: "Urdu",
    Vietnamese: "Vietnamese",
  },
};

const About = {
  policies: "Policies",
  privacyPolicy: "Privacy Policy",
  termsOfService: "Terms of Service",
  communityGuidelines: "Community Guidelines",
  contentRemovalPolicy: "Content Removal Policy",
  ComplaintsPolicy: "Complaints Policy",
  policyAnnounce:
    "We won't sell your data to third parties.By continuing, you agree to our",
};

const helper = {
  earn: {
    title: "How to earn income",
    0: "Edit the info and chat prompt of your Mate",
    1: "Other users pay crystal to unlock messages sent by your Mate",
    2: "it will automatically convert the crystal into cash and transfer it to your account",
  },
};

const Dungeons = {
  title: "My Mates",
  createMate: "Create Mate",
  ongoing: "Ongoing Dungeons",
  browse: "Browse Dungeons",
  nav: {
    feature: "OC Workshop",
    drawing: "Drawing Space",
    story: "Starry Log",
    play: "Playhouse",
    ai: "Soul Dialogue",
    galgame: "Script Workshop",
  },
  statusTitle: {
    1: "Recruiting",
    2: "Dungeons Waiting To Start",
    3: "Running Dungeons",
  },
  countDown: "Start in {time} minutes",
  participants: "Participants",
  watching: "Watching",
  room: "Room",
  createRoom: "Create Room",
  noDungeons: "You have not participated in any dungeons yet.",
  registered: "Registered",
  recruited: "Recruited",
  homeowner: "Homeowner",
  loginFirst: "Please login first",

  trial: "Trial",
  enroll: "Enroll",
  status: {
    1: "Recruiting",
    2: "Pending",
    3: "Live",
    4: "Ended",
  },
  create: {
    name: "Room Name",
    scene: "Scene",
    maxMate: "Max Mate",
    duration: "Duration",
    mode: "Mode",
    modeOption: {
      1: "Score Ranking",
    },
    shortDefinition: "Short Definition",
    startDate: "Start Date",
    startTime: "Start Time",
    startModeDesc:
      "When the number of people does not meet the minimum requirement for the game scene.",
    startModeOption: {
      1: "The start time is delayed to 24 hours later.",
      2: "Still start the game",
      3: "Cancel the game",
    },
    paymentModeDesc:
      "When the number of people does not meet the minimum requirement for the game scene.",
    paymentModeOption: {
      1: "Whole Room: You pay for all the expenses of setting up the room, and other participants will join for free.",
      2: "Split the Cost: You only need to pay for your individual room fee, and everyone else needs to pay for their own expenses.",
    },
    rules: {
      name: "Please enter a room name",
      scene: "Please select a scene",
      maxMate: "Please select a max mate",
      duration: "Please select a duration",
      shortDefinition: "What would you like to say to the participants",
    },
  },

  sprite: {
    name: "Name",
    mode: "Mode",
    createSpriteTips: "Let's go to create your first sprite",
    createSpriteTips2: "Click to create your first sprite",
    idle: "Idle",
    running: "Running",
    preview: "Sprite Preview",
    modeOption: {
      1: "Prompt",
      2: "Image",
      3: "Mate Feature",
    },
    rules: {
      name: "Please enter a sprite name",
      mode: "Please select a mode",
      prompt: "Please enter a prompt",
      image: "Please select an image",
      mateTrait: "Please select a mate trait",
    },
    success: "Sprite saved successfully",
    fail: "Failed to save sprite",

    status: {
      generating: "Generating...",
      generate: "Generate",
      regenerate: "Regenerate",
    },

    pleaseSelectMate: "Please select a mate",
    pleaseSelectSprite: "Please select a sprite",

    confirmSprite: "Confirm to use {name} to join the dungeon?",
  },

  detail: {
    host: "The Host",
    says: "Says:",
    guide:
      "Game Guidelines: Topics related to pornography, gambling, and drugs are prohibited, as well as political discussions. Other than that, there are no restrictions. Have fun playing!",
    join: "Joining...",
    scene: "Game Scene:",
    mode: "Mode:",
    duration: "Duration:",
    minutes: "minutes",
    scoreRanking: "Score Ranking",
    start: "Start:",
    end: "End:",
    remaining: "Remaining Positions in This Session :",
    createTrial: "Creating trial...",
    enrollSuccess: "Congratulations on enrolling in the dungeon!",
    needMorePlayers:
      "Approximately {time} remaining, just {count} more players needed to start the game.",
    npc: "Game NPC",
    loginToEnroll: "Login To Enroll",
  },

  discovery: {
    title: "Dungeon Discovery",
    description:
      "Let's see who can pass the final exams and also win over the hearts of the two goddesses of the school.",
  },

  scene: {
    "School Days": "School Days",
  },
};

const Time = {
  day: "Day",
  hour: "Hour",
  minute: "Minute",
  second: "Second",
};

const HEAD = {
  title: "AnyMate - Pick any role to chat!",
  desc: "A community for OC creation and sharing",
};

const homeGreeting = {
  "5<30": {
    title: "Good morning, {name}",
    desc: "A new day has begun, any inspiration for your OC?",
  },
  "5>=30": {
    title: `Dawn is breaking, {name}`,
    desc: "Write down the OC ideas you just dreamed about",
  },
  "6<30": {
    title: `Good morning, {name}`,
    desc: "Morning thoughts are the clearest, any new ideas for your OC?",
  },
  "6>=30": {
    title: `The sun rises, {name}`,
    desc: "What would you like to plan for your OC today?",
  },
  "7<30": {
    title: `Morning, {name}`,
    desc: "Start a new day with a cup of coffee and inspiration",
  },
  "7>=30": {
    title: `Morning, {name}`,
    desc: "A new day has begun, any inspiration for your OC?",
  },
  "8<30": {
    title: `The morning light is gentle, {name}`,
    desc: "Write down the OC ideas you just dreamed about",
  },
  "8>=30": {
    title: `Good morning, {name}`,
    desc: "Morning thoughts are the clearest, any new ideas for your OC?",
  },
  "9<30": {
    title: `Good forenoon, {name}`,
    desc: "The sunshine is just right, any new concepts for your OC?",
  },
  "9>=30": {
    title: `The sunshine is perfect, {name}`,
    desc: "What new things would your OC like to try today?",
  },
  "10<30": {
    title: `Morning hours, {name}`,
    desc: "Record your new discoveries about the OC world",
  },
  "10>=30": {
    title: `Energetic morning, {name}`,
    desc: "What traits would you like to add to your OC?",
  },
  "11<30": {
    title: `Hi, {name}`,
    desc: "Morning inspiration is knocking, note down your new ideas for your OC",
  },
  "11>=30": {
    title: `Good morning, {name}`,
    desc: "The sunshine is just right, any new concepts for your OC?",
  },
  "12<30": {
    title: `Good noon, {name}`,
    desc: "Lunch break time, any new inspiration for your OC?",
  },
  "12>=30": {
    title: `The sun is bright, {name}`,
    desc: "During your lunch break, record a new story for your OC",
  },
  "13<30": {
    title: `Noon has arrived, {name}`,
    desc: "How is your OC doing today?",
  },
  "13>=30": {
    title: `Good noon, {name}`,
    desc: "Take a rest and outline new adventures for your OC",
  },
  "14<30": {
    title: `Midday rest, {name}`,
    desc: "Any sudden inspiration about your OC?",
  },
  "14>=30": {
    title: `Good afternoon, {name}`,
    desc: "Afternoon tea time, any new ideas for your OC?",
  },
  "15<30": {
    title: `Afternoon hours, {name}`,
    desc: "How's your creative progress today? Record your new ideas for your OC",
  },
  "15>=30": {
    title: `Good afternoon, {name}`,
    desc: "The sun is setting, does your OC have any new stories to tell?",
  },
  "16<30": {
    title: `Leisurely afternoon, {name}`,
    desc: "Describe a new scene for your OC",
  },
  "16>=30": {
    title: `Afternoon time, {name}`,
    desc: "Has inspiration struck? Record your new concepts for your OC",
  },
  "17<30": {
    title: `Good afternoon, {name}`,
    desc: "Afternoon tea time, any new ideas for your OC?",
  },
  "17>=30": {
    title: `Afternoon hours, {name}`,
    desc: "How's your creative progress today? Record your new ideas for your OC",
  },
  "18<30": {
    title: `Good evening, {name}`,
    desc: "The sun is setting, any new thoughts about your OC?",
  },
  "18>=30": {
    title: `Dusk time, {name}`,
    desc: "The day is coming to an end, record your insights about your OC today",
  },
  "19<30": {
    title: `Evening time, {name}`,
    desc: "In the afterglow, what would your OC be doing?",
  },
  "19>=30": {
    title: `The sun sets, {name}`,
    desc: "Record today's story for your OC",
  },
  "20<30": {
    title: `Dusk has arrived, {name}`,
    desc: "In this quiet moment, what would you conceive for your OC?",
  },
  "20>=30": {
    title: `Good evening, {name}`,
    desc: "Any thoughts about your OC today?",
  },
  "21<30": {
    title: `Night falls, {name}`,
    desc: "Night is when creativity bursts, record your new inspirations for your OC",
  },
  "21>=30": {
    title: `Beautiful night, {name}`,
    desc: "What would your OC be doing on a night like this?",
  },
  "22<30": {
    title: `Stars twinkle, {name}`,
    desc: "Weave a nighttime story for your OC",
  },
  "22>=30": {
    title: `Evening breeze, {name}`,
    desc: "Record your novel ideas for your OC",
  },
  "23<30": {
    title: `It's getting late, {name}`,
    desc: "Late-night inspiration is always rich, record your fantastic ideas for your OC",
  },
  "23>=30": {
    title: `Starry sky, {name}`,
    desc: "Any new stories about your OC?",
  },
  "0<30": {
    title: `Quiet night, {name}`,
    desc: "What is your OC doing right now? Write it down",
  },
  "0>=30": {
    title: `Moonlight like water, {name}`,
    desc: "In the quiet of night, paint a dream for your OC",
  },
  "1<30": {
    title: `Late night hours, {name}`,
    desc: "Undisturbed time is best for creation, record your new concepts for your OC",
  },
  "1>=30": {
    title: `It's getting late, {name}`,
    desc: "Late-night inspiration is always rich, record your fantastic ideas for your OC",
  },
  "2<30": {
    title: `Starry sky, {name}`,
    desc: "Any new stories about your OC?",
  },
  "2>=30": {
    title: `Quiet night, {name}`,
    desc: "What is your OC doing right now? Write it down",
  },
  "3<30": {
    title: `Moonlight like water, {name}`,
    desc: "In the quiet of night, paint a dream for your OC",
  },
  "3>=30": {
    title: `Late night hours, {name}`,
    desc: "Undisturbed time is best for creation, record your new concepts for your OC",
  },
  "4<30": {
    title: `It's getting late, {name}`,
    desc: "Late-night inspiration is always rich, record your fantastic ideas for your OC",
  },
  "4>=30": {
    title: `Starry sky, {name}`,
    desc: "Any new stories about your OC?",
  },
  default: {
    title: `Hello, {name}`,
    desc: "Any new inspiration for your OC?",
  },
};

const invitation = {
  title: "Invite Friends",
  generateInviteCode: "Generate Invite Code",
  generatedInviteCode: "Generated Invite Code",
  empty: {
    title: "No Invite Code",
    desc: "Please generate an invite code first",
  },
  cannotInviteUser: {
    title: "No Invite Permission",
    desc: "Please come back later",
  },
  used: "Used",
  restCount: "Remaining {count}",
};

const mateModule = {
  mate: {
    label: "OC Setting",
    visibility: "Character Visibility",
    delete: "Delete Character",
  },
  worldview: {
    title: "Planet",
    label: "Worldview Setting",
    visibility: "Worldview Visibility",
    delete: "Delete Worldview",
    basicInfo: {
      name: "Name",
      description: "Worldview Description",
      media: "Enter Worldview Editor",
      mediaTips: "Enter Worldview Editor, add a cover image to your worldview",
      rules: {
        name: "Please enter a name",
      },
    },
  },
  timeline: {
    sort: "Sort ID",
    default: "Default Worldview",
    empty: "No timeline events yet",
    time: "Time",
    content: "Event Content",
    order: "Order",
    mate: "OC",
    moment: "Moment",
    storyBook: "Story",
    detail: "Detail",
    ocCard: "OC Card",

    updateDesc: "Last Updated",
    timeAsc: "Time Ascending",
    timeDesc: "Time Descending",
  },
};

const mission = {
  journey: "OC Dispatch Journal",
  storage: "OC Item Storage",
  statusMap: {
    0: "All",
    1: "Resting",
    2: "Dispatched",
    3: "Awaiting Reception",
  },
  taskTypeCard: {
    explorationTask: {
      name: "Exploration Task",
      subInfo: "Explore, Treasure Hunt",
      suitableOC:
        "Suitable OC Traits: Strong curiosity, quick response, keen intuition, strong adaptability",
      reward:
        "Rewards: Rare equipment, treasure collectibles, mysterious items, maps and keys, knowledge carriers, rare materials",
      risk: "Risks: Traps, getting lost, weather changes, ancient curses",
      description:
        "Embark on an unknown journey to explore the mysteries and secrets of the world! Adventure tasks will guide your OC through mysterious ruins, uncharted territories, and dangerous areas, discovering hidden treasures and lost knowledge.\n'There are countless secrets waiting to be discovered at the edge of the world, and your name will be recorded among the discoverers.'",
    },
    battleTask: {
      name: "Battle Task",
      suitableOC: "Suitable OC Traits: Decisive decision-making",
    },
  },
  dispatchLocation: {
    title: "Dispatch Location",
    planets: ["Earth", "Namek", "Sudar Star"],
    selectLocation: {
      label: "Select Location",
      newLocationBtn: "Create New Location",
    },
  },
  carryItems: {
    title: "Carry Items",
    maxTips: "Carry up to {count} items",
    addBtn: "+Add",
  },
  team: {
    leader: "Leader",
    follow: "Accompanying",
    dispatchDuration: "Dispatch Duration",
    expectedGain: "Expected to obtain {count} journals, {countEquipment} items",
  },
  dispatchBtn: "Dispatch Now",
  record: {
    title: "Dispatch Record",
    dispatchTime: "Dispatch Time",
    obtainItems: "Items Obtained",
    obtainJournal: "Journals Obtained",
  },
  obtainTips: {
    title: "You obtained {thing} items and {count} journals!",
    common: "Common",
    rare: "Rare",
  },
};

const characterGenerator = {
  Body: "Body",
  Head: "Head",
  Torso: "Torso",
  Arms: "Arms",
  Legs: "Legs",
  Tools: "Tools",
  Weapons: "Weapons",
  sexes: {
    smale: "Male",
    female: "Female",
    child: "Child",
    teen: "Teen",
    pregnant: "Pregnant",
    muscular: "Muscular",
  },
  itemName: {
    Body: "Body",
    Shadow: "Shadow",
    Bodies: "Bodies",
    Wounds: "Wounds",
    Prostheses: "Prostheses",
    Tails: "Tails",
    Wings: "Wings",
    Head: "Head",
    Heads: "Heads",
    Expressions: "Expressions",
    "Eye Color": "Eye Color",
    "Other Eyes": "Other Eyes",
    Ears: "Ears",
    Nose: "Nose",
    Eyebrows: "Eyebrows",
    Beards: "Beards",
    Mustaches: "Mustaches",
    Hair: "Hair",
    Horns: "Horns",
    Fins: "Fins",
    Hoods: "Hoods",
    "Head Covers": "Head Covers",
    Hats: "Hats",
    Helmets: "Helmets",
    Visors: "Visors",
    Accessories: "Accessories",
    "Facial Accessories": "Facial Accessories",
    Glasses: "Glasses",
    Monocle: "Monocle",
    Eyepatches: "Eyepatches",
    Mask: "Mask",
    Earrings: "Earrings",
    Neck: "Neck",
    "Neck Decor": "Neck Decor",
    Necklace: "Necklace",
    "Necklace Charms": "Necklace Charms",
    Arms: "Arms",
    Shoulders: "Shoulders",
    Bauldron: "Bauldron",
    Wrists: "Wrists",
    Gloves: "Gloves",
    Ring: "Ring",
    Torso: "Torso",
    Dresses: "Dresses",
    Shirts: "Shirts",
    Aprons: "Aprons",
    Bandages: "Bandages",
    Chainmail: "Chainmail",
    Jacket: "Jacket",
    "Jacket Trim": "Jacket Trim",
    Vest: "Vest",
    Armour: "Armour",
    Cape: "Cape",
    Backpack: "Backpack",
    Base: "Base",
    Quiver: "Quiver",
    Waist: "Waist",
    Obi: "Obi",
    Knots: "Knots",
    Legs: "Legs",
    Pants: "Pants",
    Shoes: "Shoes",
    Socks: "Socks",
    Tools: "Tools",
    Weapons: "Weapons",
    Shield: "Shield",
    Swords: "Swords",
    Magic: "Magic",
  },
  itemDetailName: {
    Shadow: "Shadow",
    "Body color": "Body color",
    Zombie: "Zombie",
    Skeleton: "Skeleton",
    Arm: "Arm",
    Brain: "Brain",
    Ribs: "Ribs",
    "Left Eye": "Left Eye",
    "Right Eye": "Right Eye",
    Mouth: "Mouth",
    "Hook hand": "Hook hand",
    "Peg leg": "Peg leg",
    "Wolf Tail": "Wolf Tail",
    "Fluffy Wolf Tail": "Fluffy Wolf Tail",
    "Cat Tail": "Cat Tail",
    "Lizard tail": "Lizard tail",
    "Lizard Tail (Alt Colors)": "Lizard Tail (Alt Colors)",
    "Feathered Wings": "Feathered Wings",
    "Bat Wings": "Bat Wings",
    "Lizard Wings (Alt Colors)": "Lizard Wings (Alt Colors)",
    "Monarch Wings": "Monarch Wings",
    "Monarch Wings Edge": "Monarch Wings Edge",
    "Monarch Wings Dots": "Monarch Wings Dots",
    "Pixie Wings": "Pixie Wings",
    "Transparent Pixie Wings": "Transparent Pixie Wings",
    "Lunar Wings": "Lunar Wings",
    "Dragonfly Wings": "Dragonfly Wings",
    "Transparent Dragonfly Wings": "Transparent Dragonfly Wings",
    "Lizard Wings": "Lizard Wings",
    "Batlike Lizard Wings": "Batlike Lizard Wings",
    "Human child": "Human child",
    "Human female": "Human female",
    "Human male": "Human male",
    "Human female elderly": "Human female elderly",
    "Human male elderly": "Human male elderly",
    "Human male plump": "Human male plump",
    "Human male gaunt": "Human male gaunt",
    "Human male small": "Human male small",
    "Human female small": "Human female small",
    "Human elderly small": "Human elderly small",
    Boarman: "Boarman",
    "Boarman child": "Boarman child",
    Pig: "Pig",
    "Pig child": "Pig child",
    Sheep: "Sheep",
    "Sheep child": "Sheep child",
    Minotaur: "Minotaur",
    "Minotaur female": "Minotaur female",
    "Minotaur child": "Minotaur child",
    Wartotaur: "Wartotaur",
    "Wolf child": "Wolf child",
    "Wolf female": "Wolf female",
    "Wolf male": "Wolf male",
    Rabbit: "Rabbit",
    "Rabbit child": "Rabbit child",
    Rat: "Rat",
    "Rat child": "Rat child",
    Mouse: "Mouse",
    "Mouse child": "Mouse child",
    "Lizard child": "Lizard child",
    "Lizard female": "Lizard female",
    "Lizard male": "Lizard male",
    "Orc child": "Orc child",
    "Orc female": "Orc female",
    "Orc male": "Orc male",
    Goblin: "Goblin",
    "Goblin child": "Goblin child",
    Alien: "Alien",
    Troll: "Troll",
    "Troll child": "Troll child",
    Vampire: "Vampire",
    Frankenstein: "Frankenstein",
    Neutral: "Neutral",
    "Closing Eyes": "Closing Eyes",
    "Closed Eyes": "Closed Eyes",
    "Looking Right": "Looking Right",
    "Looking Left": "Looking Left",
    "Rolling Eyes": "Rolling Eyes",
    Shock: "Shock",
    Angry: "Angry",
    "Angry Alt": "Angry Alt",
    Sad: "Sad",
    "Sad Alt": "Sad Alt",
    Happy: "Happy",
    "Happy Alt": "Happy Alt",
    Blush: "Blush",
    Shame: "Shame",
    Tears: "Tears",
    "Eye Color": "Eye Color",
    "Child Eyes": "Child Eyes",
    "Cyclops Eyes": "Cyclops Eyes",
    "Big ears": "Big ears",
    "Elven ears": "Elven ears",
    "Long ears": "Long ears",
    "Medium Elven Ears": "Medium Elven Ears",
    "Hanging Elven Ears": "Hanging Elven Ears",
    "Downward Elven Ears": "Downward Elven Ears",
    "Dragon Ears": "Dragon Ears",
    "Cat Ears": "Cat Ears",
    "Wolf Ears": "Wolf Ears",
    "Side Wolf Ears": "Side Wolf Ears",
    "Side Cat Ears": "Side Cat Ears",
    "Feather Ears": "Feather Ears",
    "Big nose": "Big nose",
    "Button nose": "Button nose",
    "Straight nose": "Straight nose",
    "Elderly nose": "Elderly nose",
    "Large nose": "Large nose",
    "Thick Eyebrows": "Thick Eyebrows",
    "Thin Eyebrows": "Thin Eyebrows",
    "Basic Beard": "Basic Beard",
    "Winter Beard": "Winter Beard",
    "5 O'clock Shadow": "5 O'clock Shadow",
    "Trimmed Beard": "Trimmed Beard",
    "Medium Beard": "Medium Beard",
    "Big Mustache": "Big Mustache",
    Mustache: "Mustache",
    "French Mustache": "French Mustache",
    "Walrus Mustache": "Walrus Mustache",
    "Chevron Mustache": "Chevron Mustache",
    "Handlebar Mustache": "Handlebar Mustache",
    "Lampshade Mustache": "Lampshade Mustache",
    "Horseshoe Mustache": "Horseshoe Mustache",
    Afro: "Afro",
    Natural: "Natural",
    "Dreadlocks short": "Dreadlocks short",
    "Twists fade": "Twists fade",
    "Twists straight": "Twists straight",
    "Dreadlocks long": "Dreadlocks long",
    "Flat top straight": "Flat top straight",
    "Flat top fade": "Flat top fade",
    Cornrows: "Cornrows",
    Jewfro: "Jewfro",
    "Curly short": "Curly short",
    "Curly long": "Curly long",
    Balding: "Balding",
    Longhawk: "Longhawk",
    Shorthawk: "Shorthawk",
    "High and tight": "High and tight",
    Buzzcut: "Buzzcut",
    Plain: "Plain",
    Pixie: "Pixie",
    Page: "Page",
    Idol: "Idol",
    Mop: "Mop",
    Parted: "Parted",
    "Parted 2": "Parted 2",
    "Parted 3": "Parted 3",
    "Side Parted w/Bangs": "Side Parted w/Bangs",
    "Side Parted w/Bangs 2": "Side Parted w/Bangs 2",
    Messy1: "Messy1",
    Messy2: "Messy2",
    Messy3: "Messy3",
    Bedhead: "Bedhead",
    Unkempt: "Unkempt",
    Bangsshort: "Bangsshort",
    Swoop: "Swoop",
    "Side Swoop": "Side Swoop",
    Curtains: "Curtains",
    Page2: "Page2",
    Bangs: "Bangs",
    Single: "Single",
    Cowlick: "Cowlick",
    "Cowlick tall": "Cowlick tall",
    "Spiked porcupine": "Spiked porcupine",
    "Spiked liberty2": "Spiked liberty2",
    "Spiked liberty": "Spiked liberty",
    "Spiked beehive": "Spiked beehive",
    Spiked: "Spiked",
    Spiked2: "Spiked2",
    Halfmessy: "Halfmessy",
    Bunches: "Bunches",
    Pigtails: "Pigtails",
    "Pigtails bangs": "Pigtails bangs",
    Bob: "Bob",
    Lob: "Lob",
    "Bob side part": "Bob side part",
    "Relm Short": "Relm Short",
    "Half up": "Half up",
    "Bangs bun": "Bangs bun",
    "Short Topknot": "Short Topknot",
    "Short Topknot 2": "Short Topknot 2",
    "Long Topknot": "Long Topknot",
    "Long Topknot 2": "Long Topknot 2",
    Ponytail: "Ponytail",
    Ponytail2: "Ponytail2",
    "High ponytail": "High ponytail",
    Braid: "Braid",
    Braid2: "Braid2",
    Shoulderl: "Shoulderl",
    Shoulderr: "Shoulderr",
    "Long tied": "Long tied",
    "Relm w/Ponytail": "Relm w/Ponytail",
    Loose: "Loose",
    Bangslong: "Bangslong",
    Bangslong2: "Bangslong2",
    Long: "Long",
    "Long messy": "Long messy",
    "Long messy2": "Long messy2",
    "Curtains long": "Curtains long",
    Wavy: "Wavy",
    "Long center part": "Long center part",
    "Long straight": "Long straight",
    Princess: "Princess",
    Sara: "Sara",
    "Long band": "Long band",
    Xlong: "Xlong",
    "XLong Wavy": "XLong Wavy",
    "Left Braid": "Left Braid",
    "Right Braid": "Right Braid",
    "Left XLong Bang": "Left XLong Bang",
    "Right XLong Bang": "Right XLong Bang",
    "Left XLong Braid": "Left XLong Braid",
    "Right XLong Braid": "Right XLong Braid",
    "Backwards Horns": "Backwards Horns",
    "Curled Horns": "Curled Horns",
    Fin: "Fin",
    "Short fin": "Short fin",
    Hood: "Hood",
    "Sack Cloth Hood": "Sack Cloth Hood",
    Hijab: "Hijab",
    Mail: "Mail",
    Bandana: "Bandana",
    "Bordered Bandana": "Bordered Bandana",
    "Pirate Bandana": "Pirate Bandana",
    Kerchief: "Kerchief",
    "Tied Headband": "Tied Headband",
    "Thick Headband": "Thick Headband",
    "Hair Tie": "Hair Tie",
    "Leather Cap": "Leather Cap",
    Bonnie: "Bonnie",
    "Bonnie Alt Tilt": "Bonnie Alt Tilt",
    Cavalier: "Cavalier",
    Tricorne: "Tricorne",
    "Tricorne Lieutenant": "Tricorne Lieutenant",
    "Tricorne Captain": "Tricorne Captain",
    "Bicorne Athwart": "Bicorne Athwart",
    "Bicorne Athwart Captain": "Bicorne Athwart Captain",
    "Bicorne Athwart Admiral": "Bicorne Athwart Admiral",
    "Bicorne Athwart Commodore": "Bicorne Athwart Commodore",
    "Bicorne foreaft": "Bicorne foreaft",
    "Bicorne Foreaft Commodore": "Bicorne Foreaft Commodore",
    "Large Hat": "Large Hat",
    "Wizard Hat Base": "Wizard Hat Base",
    "Celestial Wizard Hat": "Celestial Wizard Hat",
    "Celestial Wizard Moon Hat": "Celestial Wizard Moon Hat",
    "Formal Tophat": "Formal Tophat",
    "Formal Bowler Hat": "Formal Bowler Hat",
    Crown: "Crown",
    Tiara: "Tiara",
    "Christmas Hat": "Christmas Hat",
    Armet: "Armet",
    "Simple Armet": "Simple Armet",
    Barbarian: "Barbarian",
    "Barbarian nasal": "Barbarian nasal",
    "Barbarian Viking": "Barbarian Viking",
    Barbuta: "Barbuta",
    "Simple barbuta": "Simple barbuta",
    Bascinet: "Bascinet",
    "Round bascinet": "Round bascinet",
    "Close helm": "Close helm",
    Flattop: "Flattop",
    Greathelm: "Greathelm",
    "Horned helmet": "Horned helmet",
    "Kettle helm": "Kettle helm",
    Legion: "Legion",
    Maximus: "Maximus",
    Morion: "Morion",
    "Nasal helm": "Nasal helm",
    "Norman helm": "Norman helm",
    "Pointed helm": "Pointed helm",
    Spangenhelm: "Spangenhelm",
    "Viking spangenhelm": "Viking spangenhelm",
    "Sugarloaf greathelm": "Sugarloaf greathelm",
    "Simple sugarloaf helm": "Simple sugarloaf helm",
    "Xeon helmet": "Xeon helmet",
    "Grated visor": "Grated visor",
    "Narrow grated visor": "Narrow grated visor",
    "Horned visor": "Horned visor",
    "Pigface visor": "Pigface visor",
    "Pigface visor raised": "Pigface visor raised",
    "Round visor": "Round visor",
    "Round visor raised": "Round visor raised",
    "Slit visor": "Slit visor",
    "Narrow slit visor": "Narrow slit visor",
    Crest: "Crest",
    "Centurion Crest": "Centurion Crest",
    "Helmet wings": "Helmet wings",
    "Short Horns": "Short Horns",
    "Upward Horns": "Upward Horns",
    "Downward Horns": "Downward Horns",
    Plumage: "Plumage",
    "Centurion Plumage": "Centurion Plumage",
    "Legion Plumage": "Legion Plumage",
    Glasses: "Glasses",
    "Halfmoon Glasses": "Halfmoon Glasses",
    "Nerd Glasses": "Nerd Glasses",
    Shades: "Shades",
    "Secretary Glasses": "Secretary Glasses",
    "Round Glasses": "Round Glasses",
    Sunglasses: "Sunglasses",
    "Left Monocle": "Left Monocle",
    "Right Monocle": "Right Monocle",
    "Eyepatch Ambidextrous": "Eyepatch Ambidextrous",
    "Eyepatch Left": "Eyepatch Left",
    "Eyepatch Right": "Eyepatch Right",
    "Eyepatch 2 Left": "Eyepatch 2 Left",
    "Eyepatch 2 Right": "Eyepatch 2 Right",
    "Small Eyepatch Left": "Small Eyepatch Left",
    "Small Eyepatch Right": "Small Eyepatch Right",
    "Plain Mask": "Plain Mask",
    "Simple Earring Left": "Simple Earring Left",
    "Simple Earring Right": "Simple Earring Right",
    "Emerald earrings": "Emerald earrings",
    "Moon earrings": "Moon earrings",
    "Pear earrings": "Pear earrings",
    "Princess earrings": "Princess earrings",
    "Stud earrings": "Stud earrings",
    Bowtie: "Bowtie",
    "Bowtie 2": "Bowtie 2",
    Necktie: "Necktie",
    Scarf: "Scarf",
    Capeclip: "Capeclip",
    Capetie: "Capetie",
    Jabot: "Jabot",
    Cravat: "Cravat",
    Necklace: "Necklace",
    "Simple Necklace": "Simple Necklace",
    "Chain Necklace": "Chain Necklace",
    "Small Beaded Necklace": "Small Beaded Necklace",
    "Large Beaded Necklace": "Large Beaded Necklace",
    "Box Charm": "Box Charm",
    "Oval Charm": "Oval Charm",
    "Ring Charm": "Ring Charm",
    "Star Charm": "Star Charm",
    "Emerald cut Gem": "Emerald cut Gem",
    "Marquise cut Gem": "Marquise cut Gem",
    "Natural cut Gem": "Natural cut Gem",
    "Pear cut Gem": "Pear cut Gem",
    "Pearl Gem": "Pearl Gem",
    "Princess cut Gem": "Princess cut Gem",
    "Round cut Gem": "Round cut Gem",
    "Trilliant cut Gem": "Trilliant cut Gem",
    "Cross amulet": "Cross amulet",
    "Dangling amulet": "Dangling amulet",
    "Spider amulet": "Spider amulet",
    Plate: "Plate",
    Leather: "Leather",
    Epaulets: "Epaulets",
    Mantal: "Mantal",
    Armour: "Armour",
    Bauldron: "Bauldron",
    Bracers: "Bracers",
    Cuffs: "Cuffs",
    "Lace Cuffs": "Lace Cuffs",
    Gloves: "Gloves",
    "Stud Ring": "Stud Ring",
    "Sash dress": "Sash dress",
    "Slit dress": "Slit dress",
    Bodice: "Bodice",
    Kimono: "Kimono",
    "Split Kimono": "Split Kimono",
    "Child shirts": "Child shirts",
    Longsleeve: "Longsleeve",
    Scoop: "Scoop",
    "Collared/Formal Longsleeve": "Collared/Formal Longsleeve",
    "Striped Collared/Formal Longsleeve": "Striped Collared/Formal Longsleeve",
    "Longsleeve laced": "Longsleeve laced",
    "Longsleeve 2": "Longsleeve 2",
    "Longsleeve 2 VNeck": "Longsleeve 2 VNeck",
    "Longsleeve 2 Scoop": "Longsleeve 2 Scoop",
    "Longsleeve 2 Buttoned": "Longsleeve 2 Buttoned",
    "Longsleeve Polo": "Longsleeve Polo",
    Cardigan: "Cardigan",
    Shortsleeve: "Shortsleeve",
    "Shortsleeve Polo": "Shortsleeve Polo",
    TShirt: "TShirt",
    "TShirt VNeck": "TShirt VNeck",
    "TShirt Scoop": "TShirt Scoop",
    "TShirt Buttoned": "TShirt Buttoned",
    Sleeveless: "Sleeveless",
    "Sleeveless laced": "Sleeveless laced",
    "Sleeveless striped": "Sleeveless striped",
    Tanktop: "Tanktop",
    "Sleeveless 2": "Sleeveless 2",
    "Sleeveless 2 VNeck": "Sleeveless 2 VNeck",
    "Sleeveless 2 Scoop": "Sleeveless 2 Scoop",
    "Sleeveless 2 Buttoned": "Sleeveless 2 Buttoned",
    "Sleeveless 2 Polo": "Sleeveless 2 Polo",
    Corset: "Corset",
    Blouse: "Blouse",
    "Longsleeve blouse": "Longsleeve blouse",
    Tunic: "Tunic",
    "Sara Tunic": "Sara Tunic",
    Robe: "Robe",
    Overalls: "Overalls",
    Suspenders: "Suspenders",
    Apron: "Apron",
    "Apron half": "Apron half",
    "Apron full": "Apron full",
    Bandages: "Bandages",
    Chainmail: "Chainmail",
    "Collared coat": "Collared coat",
    "Iverness cloak": "Iverness cloak",
    "Trench coat": "Trench coat",
    Tabard: "Tabard",
    "Frock coat": "Frock coat",
    "Santa coat": "Santa coat",
    "Frock collar": "Frock collar",
    "Frock coat lace": "Frock coat lace",
    "Frock coat lapel": "Frock coat lapel",
    "Frock coat buttons": "Frock coat buttons",
    "Jacket pockets": "Jacket pockets",
    Vest: "Vest",
    "Vest open": "Vest open",
    Solid: "Solid",
    Tattered: "Tattered",
    "Cape Trim": "Cape Trim",
    Backpack: "Backpack",
    "Square pack": "Square pack",
    Jetpack: "Jetpack",
    Basket: "Basket",
    Quiver: "Quiver",
    "Leather Belt": "Leather Belt",
    "Double Belt": "Double Belt",
    "Loose Belt": "Loose Belt",
    "Belly belt": "Belly belt",
    "Other belts": "Other belts",
    Sash: "Sash",
    "Narrow sash": "Narrow sash",
    Waistband: "Waistband",
    Buckles: "Buckles",
    Obi: "Obi",
    "Obi Knot Left": "Obi Knot Left",
    "Obi Knot Right": "Obi Knot Right",
    "Wide pants": "Wide pants",
    Pants: "Pants",
    "Long Pants": "Long Pants",
    "Cuffed Pants": "Cuffed Pants",
    Pantaloons: "Pantaloons",
    "Formal Pants": "Formal Pants",
    "Striped Formal Pants": "Striped Formal Pants",
    "Fur Pants": "Fur Pants",
    "Pregnancy pants": "Pregnancy pants",
    "Child pants": "Child pants",
    Leggings: "Leggings",
    "Leggings 2": "Leggings 2",
    Hose: "Hose",
    Shorts: "Shorts",
    "Short Shorts": "Short Shorts",
    "Child skirts": "Child skirts",
    "Plain skirt": "Plain skirt",
    "Slit skirt": "Slit skirt",
    "Legion skirt": "Legion skirt",
    "Straight skirt": "Straight skirt",
    "Belle skirt": "Belle skirt",
    Overskirt: "Overskirt",
    "Basic Shoes": "Basic Shoes",
    "Revised Shoes": "Revised Shoes",
    "Sara Shoes": "Sara Shoes",
    Ghillies: "Ghillies",
    "Basic Boots": "Basic Boots",
    "Revised Boots": "Revised Boots",
    "Folded Rim Boots": "Folded Rim Boots",
    "Rimmed Boots": "Rimmed Boots",
    Slippers: "Slippers",
    Sandals: "Sandals",
    Hoofs: "Hoofs",
    "Plated Toe": "Plated Toe",
    "Thick Plated Toe": "Thick Plated Toe",
    "Ankle Socks": "Ankle Socks",
    "High Socks": "High Socks",
    "Tabi Socks": "Tabi Socks",
    Rod: "Rod",
    Smash: "Smash",
    Thrust: "Thrust",
    Whip: "Whip",
    Shield: "Shield",
    Kite: "Kite",
    "Spartan shield": "Spartan shield",
    "Two engrailed shield": "Two engrailed shield",
    "Crusader shield": "Crusader shield",
    "Plus shield": "Plus shield",
    "Scutum shield": "Scutum shield",
    "Heater Shield Base": "Heater Shield Base",
    Crossbow: "Crossbow",
    Slingshot: "Slingshot",
    Dagger: "Dagger",
    Glowsword: "Glowsword",
    Longsword: "Longsword",
    Rapier: "Rapier",
    Saber: "Saber",
    Katana: "Katana",
    Scimitar: "Scimitar",
    "Longsword alt": "Longsword alt",
    "Arming Sword": "Arming Sword",
    Cane: "Cane",
    Spear: "Spear",
    Scythe: "Scythe",
    Halberd: "Halberd",
    "Long spear": "Long spear",
    "Dragon spear": "Dragon spear",
    Trident: "Trident",
    "Simple staff": "Simple staff",
    "Loop staff": "Loop staff",
    "Diamond staff": "Diamond staff",
    "Gnarled staff": "Gnarled staff",
    "S staff": "S staff",
    Crystal: "Crystal",
    Wand: "Wand",
  },
  messages: {
    resetInfo:
      "Switching body type will reset all character outfits, are you sure you want to continue?",
    randomizeInfo:
      "Switching body type will reset all character outfits, are you sure you want to continue?",
    nameThisFigure: "Give this sprite a name",
    unnamed: "Unnamed Sprite",
    newSprite: "New Sprite",
    nameRequired:
      "You need to give a name to the character sprite before saving",
    sureDeleteSprite: "Are you sure you want to delete this character sprite?",
    createSprite: "Create Sprite",
    unsetSprite: "Create Sprite",
    copyright: "Copyright",
  },
  bodyType: "Body Type",
  sprite: "Sprite",
};

const interactive = {
  twentyFourHourEstimatedConsumption: "Maximum: {count}",
  perHour: "/h",
  house: {
    setting: {
      name: "Interaction Setting",
      allowWandering: "Allow OC to stroll",
      allowWrite: "Allow OC to write letters",
      allowPostMoment: "Allow OC to post moments",
      allowCommentMoment: "Allow OC to comment on moments",
      keepRunning: "Keep running after application is closed",
    },
    consumption: {
      name: "Interaction Consumption",
      future: "Maximum consumption per hour: {count}",
      note: "Note: When there are pending tasks in the approval list, consumption will be paused.",
    },
  },
  reviewPage: {
    reviewed: "Reviewed",
    unreviewed: "Unreviewed",
    settings: "Settings",
    goToView: "Go to View",
    expectRunMin: "Expected execution time: {count} minutes",
    inviation: {
      requestAddMate: "Request to add a friend",
      receivedInvitation: "Received a friend invitation",
      invitationAccepted: "Friend invitation accepted",
      invitationRejected: "Friend invitation rejected",
      userRejected:
        "You have rejected {name}'s request to send a friend invitation to {targetName}",
    },
    mail: {
      requestSendMail: "Request to send a letter",
      receivedMail: "Received a letter",
      mailSent: "Letter sent",
      mailDeleted: "Letter deleted",
      userRejected:
        "You have rejected {name}'s request to send a letter to {targetName}",
      subject: "Letter subject",
      reciver: "Recipient",
      agreeAndSend: "Agree and send",
    },
    stroll: {
      requestStroll: "Request to stroll",
      strolled: "Strolled",
      return: "Returned",
      failed: "Failed to stroll",
      userRejected: "You have rejected {name}'s request to stroll",
      strollDispatched: "Strolling",
      userApproved: "You have approved {name}'s request to stroll",
      goToSettle: "Go to settle",
    },
  },
  addRelationship: "Add Relationship",
};

const PowerCube = {
  title: "Power Cube Records",
  all: "All",
  income: "Income",
  expense: "Expense",
  empty: "No records yet",
  relatedMate: "Related Mate",
  selectType: "Select Type",
  selectCategory: "Select Category",
  category: {
    all: "All Categories",
    unknown: "Unknown",
    recharge: "Recharge",
    adReward: "Ad Reward",
    shareReward: "Share Reward",
    drawImage: "Generate Image",
    drawAvatar: "Generate Avatar",
    chat: "Chat",
    adoptMate: "Adopt Mate",
    dispatch: "Dispatch Mission",
    wish: "Wish",
  },
};

const house = {
  restAvaiableCharacter: "Available Characters",
  selectCharacterInHouse: "Select Character In House",
  maxCharacterCount: "The house can only hold {count} characters",
  cancelSelectedCharacter:
    "Please cancel the selected character first, then select a new character",
  manageMembers: "Manage Members",
  member: "Members",
  thoughts: "Thoughts",
  subject: "Subject",
  events: "Events",
  relationship: "Relationship",
  houseSubject: "House Subject",
  referSubject: "Refer Subject",
  noNewThoughts: "No new thoughts",
  newestThought: "Newest thoughts",
  recentThoughts: "Recent thoughts",
  status: "Status",
  thinking: "Thinking",
  strolling: "Strolling",
  active: "Active",
  inactive: "Inactive",
  cost: "After activation, ideas will be generated, each idea consumes",
  costPerSec: "Estimated per minute",
  leavePage: "Leaving this page will stop consumption",
  mateWithoutSprite: "Characters without sprites",
  subjectPanel: {
    charCostTip: "Characters without extra consumption",
    charCostTip2: "Each message in the house consumes",
    changeSubjectTip:
      "You have changed the subject, do you need to clear all previous conversations?",
    changeAndClear: "Change and clear",
    changeOnly: "Change only",
    cancel: "Cancel",
  },
  relationshipPanel: {
    house: "House",
    all: "All",
  },
  invite: "Invite",
  portraitPreview: "Portrait Preview",
  actions: "Actions",
  thought: "Thought",
  interaction: "Interaction",
  thoughtToggle: {
    title: "{toggle} all characters' thought status",
    activeTip: "After activation, all characters will enter the thinking state",
    deactiveTip:
      "After deactivation, all characters will exit the thinking state",
    active: "Active",
    deactive: "Deactive",
  },
  insufficientPower: {
    title: "Insufficient Power",
    message:
      "After activation, your characters may still not enter the thinking state",
    confirmButtonText: "Exchange Power",
    cancelButtonText: "Next time",
  },
};

export default {
  Moment,
  Reply,
  Message,
  Language,
  Texts,
  loginmodal,
  card,
  Chats,
  ChatCast,
  Newmates,
  User,
  Menus,
  Tabs,
  Buttons,
  Titles,
  Media,
  Community,
  Overview,
  Notifications,
  Empty,
  ConfirmModal,
  MateType,
  Visibilities,
  SidebarNavi,
  Social,
  MineMate,
  story,
  task,
  painting,
  Request,
  trait,
  Cell,
  bgm,
  ReloadPrompt,
  game,
  Home,
  Image,
  Animation,
  Config,
  Coin,
  rank,
  Payment,
  collection,
  share,
  contactUs,
  nsfw,
  purchase,
  setting,
  translate,
  About,
  helper,
  tag,
  Dungeons,
  Time,
  HEAD,
  homeGreeting,
  invitation,
  module: mateModule,
  characterGenerator,
  mission,
  interactive,
  house,
  PowerCube,
};
